/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-09 16:41:54
 * @LastEditTime: 2019-12-19 10:53:49
 * @LastEditTime: 2019-09-09 11:43:43
 * @LastEditors: Please set LastEditors
 */

export default {
  v5: {
    my_video_shorts: 'VIDEO ZANGU MFUPI',
    see_more: 'ONA ZAIDI',
    no_shorts_found: 'Hakuna Shorts Zilizopatikana',
    shorts: 'Shorts',
    general_information: 'Taarifa za Jumla',
    gamification: 'Gamification',
    click_to_select_files: 'Bonyeza kuchagua faili',
    selected_files: 'Faili zilizochaguliwa',
    uploaded: 'Imewekwa',
    failed: 'Imeshindikana',
    system_will_automatically_analyze_and_select_the_most_relevant:
      'Mfumo utachambua moja kwa moja na kuchagua nyaraka zinazofaa zaidi kutoka maktaba ya shirika lako kulingana na mahitaji ya maudhui.',
    select_from_library: ' Chagua kutoka maktaba',
    search_document: 'Tafuta nyaraka...',
    selected: 'Imechaguliwa',
    loading_documents: 'Inapakia nyaraka...',
    review_generated_content: 'Kagua maudhui yaliyoundwa',
    confirm_and_replace_content: 'Thibitisha na badilisha maudhui',
    the_generate_content_will_replace:
      'Maudhui yaliyoundwa yatabadilisha maandishi yaliyopo kwenye kurasa zilizochaguliwa. Ikiwa hutaki kutumia mabadiliko haya, unaweza kurudi kwenye hatua iliyotangulia.',
    pages_to_be_updated: 'Kurasa za kusasishwa',
    generated_revisions: 'Mapitio yaliyoundwa',
    lesson_preview: 'Mwoneko wa somo',
    create_new_folder: 'Unda folda mpya',
    rename_item: 'Badilisha jina la kipengee',
    enter_folder_name: 'Ingiza jina la folda:',
    enter_new_name: 'Ingiza jina jipya:',
    folder_name: 'Jina la folda:',
    new_name: 'Jina jipya',
    move_items: 'Hamisha vipengee',
    copy_items: 'Nakili vipengee',
    move_here: 'Hamisha hapa',
    copy_here: 'Nakili hapa',
    select_destination_library_and_folder: 'Chagua maktaba na folda ya mwisho:',
    items_selected: 'Vipengee vilichaguliwa',
    version: 'Toleo',
    modified_by: 'Imebadilishwa na',
    size: 'Ukubwa',
    restore: 'Rekebisha',
    are_you_sure_you_want_to_restore_this_version:
      'Una uhakika unataka kurekebisha toleo hili?',
    this_will_replce_the_current_version_with_the_selected_one:
      'Hii itabadilisha toleo la sasa na lile lililochaguliwa.',
    restore_this_version: 'Rekebisha toleo hili',
    restore_not_available: 'Kurekebisha hakupatikani',
    version_history: 'Historia ya matoleo:',
    by_making_items_public:
      'Kwa kufanya vipengee kuwa vya umma, vitakuwa vinaonekana kwa kila mtu. Tafadhali hakiki masharti kabla ya kuendelea.',
    the_selected_items_will_be_copied:
      'Vipengee vilivyochaguliwa vitanakiliwa kwenye maktaba yako ya umma na vinaonekana kwa kila mtu.',
    the_selected_items_will_be_copied_to_org:
      'Vipengee vilivyochaguliwa vitanakiliwa kwenye maktaba ya shirika lako na vinaonekana kwa wanachama wote wa shirika.',
    the_selected_items_will_be_copied_to_your_private:
      'Vipengee vilivyochaguliwa vitanakiliwa kwenye maktaba yako binafsi na vinaonekana kwa wewe pekee.',
    loading_organization: 'Inapakia watumiaji wa shirika...',
    click_download_to_view: 'Bonyeza "Pakua" ili kuona',
    archive_file: 'Faili la kuhifadhi',
    no_preview_available: 'Hakuna muonekano uliopo',
    audit_report: 'Ripoti ya ukaguzi',
    audit_type: 'Aina ya kitendo',
    i_agree_to_the_terms_and_conditions: 'Nakubaliana na masharti na masharti.',
    this_file_is_indexed_for_ai: 'Faili hili limeorodheshwa kwa AI.',
    file_is_not_indexed_for_ai: 'Faili haijaorodheshwa kwa AI.',
    no_users_found: 'Hakuna watumiaji waliopatikana',
    no_users_available: 'Hakuna watumiaji waliopo',
    add_people: 'Ongeza watu',
    people: 'Watu',
    access_type: 'Aina ya ufikiaji',
    no_group_found: 'Hakuna makundi yaliyo patikana',
    add_group: 'Ongeza makundi',
    groups: 'Makundi',
    users_top: 'mtumiaji(wa)',
    confirm_delete: 'Thibitisha ufutaji',
    do_you_want_remove: 'Una uhakika unataka kuondoa',
    form_this_documents_permissions: 'kutoka kwenye ruhusa za hati hii?',
    no_users_found_in_this_group:
      'Hakuna watumiaji katika kundi hili waliopatikana',
    add_selected_users: 'Ongeza watumiaji waliyochaguliwa',
    choose_users_from_the_list: 'Chagua watumiaji kutoka kwenye orodha',
    selected_users: 'Watumiaji waliyochaguliwa',
    archived: 'Imetumwa kwenye faili la hifadhi',
    request_approval: 'Omba idhini',
    document_in_review: 'Hati inakaguliwa',
    approve: 'Kubali',
    reject: 'Kataa',
    comment: 'Maoni:',
    enter_your_commit: 'Weka maoni yako...',
    confirm_cancel: 'Thibitisha kughairi',
    upload_3d_zip: 'Pakia ZIP 3D',
    delete_items: 'Futa vipengee',
    video_upload_request: 'Ombi la kupakia video',
    reject_video: 'Kataa video',
    enter_rejection_reason: 'Weka sababu ya kukataa...',
    please_provide_a_reason_for_reejection_this_video:
      'Tafadhali toa sababu ya kukataa video hii:',
    generate_trivia_with_ai: 'Tengeneza trivia kwa AI',
    select_category: 'Chagua kategoria:',
    number_of_question: 'Idadi ya maswali',
    generated_questions: 'Maswali yaliyoundwa',
    this_will_clear_all_generate_question:
      'Hii itafuta maswali yote yaliyoundwa. Endelea?',
    sure_delete: 'Una uhakika unataka kufuta?',
    delete_this_question: 'Una uhakika unataka kufuta swali hili?',
    loading_quiz: 'Inapakia mtihani...',
    creteing_file: 'Inaunda faili',
    opening_desktop_app: 'Inafungua programu ya desktop',
    this_folder_is_empty: 'Foda hii haina kitu',
    select_a_competition: 'Chagua shindano...',
    activity_badges: 'Bango za shughuli',
    awarded_every_badges:
      'Zinapewa kila 4, 8, 16, 32, 64, 128, 256, 512 kuingia',
    learning_badges: 'Bango za kujifunza',
    awarded_every_courses:
      'Zinapewa kila 1, 4, 8, 16, 32, 64, 128 kozi zilizokamilika',
    test_badges: 'Bango za mtihani',
    awarded_every_passes_tests:
      'Zinapewa kila 2, 4, 8, 16, 32, 64, 128, 256 mtihani uliopitishwa',
    assignment_badges: 'Bango za kazi',
    awarded_every_passed_assignments:
      'Zinapewa kila 1, 2, 4, 8, 16, 32, 64, 128 kazi zilizokamilika',
    perfectionism_badges: 'Bango za ukamilifu',
    awarded_every_assignments_with_scrore:
      'Zinapewa kila 1, 2, 4, 8, 16, 32, 64, 128 mtihani au kazi zilizo na alama ya 90%+',
    communication_badges: 'Bango za mawasiliano',
    awarded_every_topics_or_comments:
      'Zinapewa kila 2, 4, 8, 16, 32, 64, 128, 256 mada au maoni',
    certification_badges: 'Bango za vyeti',
    awarded_every_certificates:
      'Zinapewa kila 1, 2, 4, 8, 16, 32, 64, 128 vyeti',
    level_name: 'Jina la kiwango',
    delete_competition: 'Futa shindano',
    this_week: 'Wiki hii',
    this_year: 'Mwaka huu',
    make_organization: 'Tengeneza shirika',
    no_results_found: 'Hakuna matokeo yaliyopatikana kwa',
    no_items_available: 'Hakuna vipengee vilivyopo',
    help_video: 'Video za msaada',
    select_a_video_from_the_list:
      'Chagua video kutoka kwenye orodha ili kuanza kujifunza'
  },
  v4: {
    drop_files: 'Telezesha faili na chagua mahali pa kupakia.',
    duplicate_lessoon: 'Somo tayari lipo kwenye kozi',
    skill_rule_title: 'Tafadhali ingiza Kichwa cha Safari ya Ujuzi',
    imageCreatorTitle: 'Muumba wa Picha',
    isTranslated: 'Imetafsiriwa',
    translationCourseDesc:
      'Tafsiri ya kozi hii inaweza kuchukua dakika chache. Asante kwa uvumilivu wako!',
    translateCourseTip:
      'Tengeneza kozi iliyotafsiriwa ambayo unaweza kuhariri kwa uhuru tofauti na asili, ikiwa na somo zote na kurasa.',
    translateModalBtn: 'Tafsiri',
    translationSuccess: 'Kozi “<0/>” imetafsiriwa kwa mafanikio!',
    translatingCourse: 'Tafasiri kozi...',
    translateModalTitle: 'Tafsiri Kozi',
    translateSelectLang: 'Chagua Lugha',
    fileDeleteconfirm:
      'Je, una uhakika unataka kufuta faili hii? Kitendo hiki hakiwezi kughairiwa.',
    fileDeleteMessage: 'Faili imefutwa kwa mafanikio.',
    fileDeleteFailedMessage: 'Imeshindikana kufuta faili!',
    fileDelete: 'Futa faili hii.',
    certificate_save_btn: 'Ongeza Cheti kwa ',
    maze_path_info: 'Hakuna njia zinazopatikana kwenye chati!',
    file_size_mb: 'Saizi ya faili lazima iwe chini ya MB 25!',
    reports: {
      products: 'Bidhaa',
      users: 'Watumiaji',
      ph_username: 'Tafuta mtumiaji kwa jina la mtumiaji',
      ph_id: 'Tafuta mtumiaji kwa nambari ya ID',
      ph_email: 'Tafuta mtumiaji kwa barua pepe'
    },
    select_upload_section_id: 'Faili la sehemu linahitajika',
    tags_all: 'Zote',
    delete_file_confirm: 'Je, una uhakika unataka kufuta faili hii?',
    delete_file_title: 'Futa Faili',
    tooltip_publish: 'Chapisha kozi kwa chaguo ulioteuliwa',
    tooltip_save: 'Hifadhi kozi na masasisho ya sasa',
    tooltip_next: 'Nenda kwenye usanidi mwingine wa kozi',
    tooltip_finish: 'Maliza na hifadhi masasisho ya sasa',
    stories_modal: {
      title_upload: 'Pakia Hadithi',
      title_update: 'Sasisha Hadithi',
      title_audio: 'Faili ya Hadithi ya Sauti',
      btn_upload: 'Pakia',
      btn_update: 'Sasisha',
      btn_close: 'Funga',
      btn_cancel: 'Ghairi',
      lbl_cover: 'Picha ya Jalizi ya Hadithi',
      rule_cover: 'Tafadhali pakia jalizi ya sauti ya hadithi!',
      lbl_title: 'Kichwa cha Sauti ya Hadithi',
      rule_title: 'Tafadhali ingiza kichwa cha sauti ya hadithi!',
      lbl_description: 'Maelezo ya Sauti ya Hadithi',
      rule_description: 'Tafadhali ingiza maelezo ya sauti ya hadithi!',
      lbl_file: 'Pakia faili ya sauti ya hadithi',
      rule_file: 'Tafadhali pakia faili ya sauti ya hadithi!',
      rule_file_type: 'Tafadhali pakia faili halali ya sauti ya hadithi!',
      lbl_select_file: 'Chagua faili ya sauti ya hadithi',
      msg_valid_file: 'Tafadhali chagua faili halali ya sauti ya hadithi!',
      msg_success: 'Faili ya sauti ya hadithi imepakiwa kwa mafanikio',
      msg_failed: 'Imeshindikana kuweka data ya vyombo vya habari!',
      msg_error: 'Tatizo lilipotokea wakati wa kupakia faili!'
    },
    audio_modal: {
      title_upload: 'Pakia',
      title_update: 'Sasisha',
      title_audio: 'Faili ya Sauti',
      btn_upload: 'Pakia',
      btn_update: 'Sasisha',
      btn_close: 'Funga',
      btn_cancel: 'Ghairi',
      lbl_cover: 'Jalizi ya Sauti',
      rule_cover: 'Tafadhali pakia jalizi ya sauti!',
      lbl_title: 'Kichwa cha Sauti',
      rule_title: 'Tafadhali ingiza kichwa cha sauti!',
      lbl_description: 'Maelezo ya Sauti',
      rule_description: 'Tafadhali ingiza maelezo ya sauti!',
      lbl_file: 'Pakia faili ya sauti',
      rule_file: 'Tafadhali pakia faili ya sauti!',
      rule_file_type: 'Tafadhali pakia faili halali ya sauti!',
      lbl_select_file: 'Chagua faili ya sauti',
      msg_valid_file: 'Tafadhali chagua faili halali ya sauti!',
      msg_success: 'Faili ya sauti imepakiwa kwa mafanikio',
      msg_failed: 'Imeshindikana kuweka data ya vyombo vya habari!',
      msg_error: 'Tatizo lilipotokea wakati wa kupakia faili!'
    },
    info_episode: 'Picha ya jalizi ya kipindi.',
    btn_delete_episode: 'Futa kipindi hiki cha podikasti.',
    btn_edit_marketplace: 'Hariri Maelezo ya Soko.',
    btn_save_marketplace: 'Hifadhi mabadiliko ya sasa.',
    btn_ai_podcast: 'Tengeneza kipindi cha podikasti kwa AI.',
    btn_upload_podcast: 'Pakia kipindi chako cha sauti cha podikasti.',
    attach_file: 'Pakia faili ili kushiriki maudhui zaidi na watazamaji wako',
    fileDownload: 'Pakua faili hii.',
    singleEpishode: 'Kipindi',
    podcast_music: 'podikasti, muziki & hadithi',
    publishHeader: 'Chapisha Podikasti, Muziki & Hadithi',
    editHeader: 'Hariri Podikasti, Muziki & Hadithi',
    createHeader: 'Tengeneza Podikasti, Muziki & Hadithi',
    marketplaceHeader: 'Maelezo ya Soko la Podikasti, Muziki & Hadithi',
    message_marketplace: 'Tafadhali jaza fomu ya soko!',
    create_podcast_live: 'Podikasti na Muziki Moja kwa Moja',
    create_podcast_custom: 'Podikasti na Muziki Maalum',
    create_podcast_stories: 'Hadithi',
    ai_Assisted_podcast_reation: 'Podikasti na Muziki yenye Usaidizi wa AI',
    publishTitle: 'Chapisha podikasti, muziki & hadithi kwa watazamaji.',
    customButton: 'Tengeneza Maalum',
    customTitle: 'Hifadhi mabadiliko yaliyofanywa kwenye podikasti.',
    updateButton: 'Sasisha',
    createButton: 'Tengeneza',
    createNewButton: 'Tengeneza Mpya',
    updateTitle: 'Sasisha maelezo ya sasa ya podikasti, muziki & hadithi.',
    createTitle: 'Tengeneza podikasti, muziki & hadithi mpya',
    createNewTitle:
      'Podikasti mpya, muziki & hadithi itatengenezwa kutoka kwa maelezo yaliyopo.',
    podcastTitle: 'Orodha ya Vipindi',
    podcastStoryTitle: 'Orodha ya Vipindi vya Hadithi',
    podcastToolTipTitle: 'Orodha ya vipindi vya podikasti',
    uploadAudio: 'Pakia Sauti',
    aiAudio: 'Sauti ya AI',
    emptyPodcast: 'Bado hakuna kurekodiwa kwa podikasti, muziki au hadithi.',
    emptyStoriesPodcast: 'Hakuna hadithi zilizoongezwa bado.',
    emptyCreatePodcast: 'Tafadhali tengeneza podikasti ili kuongeza sauti.',
    playPodcast: 'Chezesha podikasti, muziki & hadithi uliyochagua.',
    pausePodcast: 'Sitisha podikasti, muziki & hadithi uliyochagua.',
    selectPodcast: 'Chagua podikasti, muziki & hadithi hii.',
    downloadPodcast: 'Pakua sauti hii.',
    uploadAudioFile: 'Pakia sauti mpya na ubadilishe ile ya sasa.',
    deleteConfirm: 'Je, una uhakika unataka kufuta sauti hii?',
    roomName: 'Jina la Podikasti',
    addGuestTitle: 'ONYESHA MGENI',
    showTime: 'Muda wa Maonyesho',
    startTime: 'Wakati wa Kuanzia',
    endTime: 'Wakati wa Hitimisho',
    erorMsgImg: 'Tafadhali chagua picha halali.',
    failedMsgImg: 'Imeshindwa kupakia picha. Tafadhali jaribu tena!',
    failedMsgUpload: 'Imeshindwa kupakia jalizi!',
    btnCoverUpload: 'Pakia Jalizi',
    is_private: 'Binafsi',
    to_attach: 'Ambatisha Faili',
    file_attached: 'Faili Zilambatanishwa',
    main_event: 'Tukio Kuu',
    event: 'Tukio',
    upload_pdf: 'Pakia PDF',
    portrait: 'Safu Wima',
    landscape: 'Safu Wima',
    import_from_library: 'Weka maandishi kutoka Maktaba ya Vyombo',
    question_answer_ai: 'AI ya Maswali/Majibu',
    take_maze: 'ANZA MetaMaze',
    training: 'Mafunzo',
    select_transcribe_locale: 'Chagua Lugha ya Kunakili',
    transcribe_limit: 'Tafadhali weka Dakika za Kunakili',
    not_complete: 'Taarifa za Soko Hazijakamilika',
    complete: 'Taarifa za Soko Zimekamilika',
    not_admin: 'Unahitaji Haki za Msimamizi Kuchapisha kwenye Soko',
    no_course: 'Tafadhali weka Kichwa na Chagua Picha ili Kuwezesha Soko',
    scorm_not_complete:
      'Tafadhali weka Kichwa na Chagua Picha ili Kupakia Faili ya SCORM',
    not_found_maze: 'MetaMaze Haikupatikana',
    email_require: 'Barua Pepe Zinahitajika',
    poll_required: 'Takwimu za Kura Zinahitajika',
    alert: 'Tahadhari!',
    warning: 'Onyo!',
    ok: 'Sawa',
    cancel: 'Ghairi',
    done: 'Imekamilika',
    insert: 'Weka',
    private: 'Binafsi',
    public: 'Ya Umma',
    no_connection: 'Muunganisho wa Intaneti Umepotea',
    switch: 'Badilisha',
    share_screen: 'Shiriki Skrini',
    stop_share_screen: 'Acha Kushiriki Skrini',
    share_screen_with_camera: 'Shiriki Skrini na Kamera',
    stop_share_screen_with_camera: 'Acha Kushiriki Skrini na Kamera',
    camera_on: 'Kamera Imewashwa',
    camera_off: 'Kamera Imezimwa',
    mic_on: 'Washa Kipaza Sauti',
    mic_off: 'Zima Kipaza Sauti',
    fullscreen: 'Skrini Nzima',
    live_now: 'Moja kwa Moja',
    schedule_on: 'Pangilia kwa',
    organisations: 'Mashirika',
    org_groups: 'Makundi ya Shirika',
    specific_user: 'Mtumiaji Mahususi',
    gif: 'GIF',
    unavailable: 'Haipatikani',
    yes: 'Ndiyo',
    no: 'Hapana',
    event_duration_message: 'Dakika 300 za Juu (Saa 5)',
    send_email: 'Tuma Arifa kwa Barua Pepe',
    admin_only: 'Kwa Wasimamizi Pekee',
    join: 'Jiunge',
    leave: 'Ondoka',
    share: 'Shiriki',
    share_text:
      'Tafadhali andika barua pepe ya mtu unayetaka kushirikiana naye faili hii.',
    share_text_title: 'Shiriki PDF',
    share_text_title_txt: 'Shiriki Maandishi',
    select_users: 'Chagua Watumiaji',
    delete: 'Futa',
    attachment_event: 'Viambatisho kwa Tukio:',
    transcribe_limit: 'Dakika za Kunakili',
    monthly_transcribe: 'Kikomo cha Kunakili kwa Mwezi:',
    enable_ai: 'Wezesha AI:',
    enable_maze: 'Wezesha MetaMaze:',
    media_service: 'Huduma ya Vyombo vya Habari',
    allow_others: 'Ruhusu Wengine Kuhariri',
    join_breakout_room: 'Jiunge na Chumba cha Majadiliano',
    bio: 'Wasifu',
    linkedin: 'LinkedIn',
    select_org_report:
      'Tafadhali tafuta na uchague shirika kutengeneza ripoti.',
    org_image_not_found: 'Picha Haikupatikana',
    insert_text: 'Weka Maandishi',
    insert_question_answer: 'AI ya Maswali/Majibu',
    modal_title2: 'Maktaba ya Maandishi',
    my_text_library: 'Maktaba Yangu ya Maandishi',
    ai: 'AI',
    public_text_library: 'Maktaba ya Maandishi ya Umma',
    organization_text_library: 'Maktaba ya Maandishi ya Shirika',
    no_transcribed_text: 'Hakuna Maandishi Yaliyotafsiriwa Yaliyopatikana',
    public_text_not_found: 'Maandishi ya Umma Yaliyotafsiriwa Hayakupatikana',
    org_text_not_found: 'Maandishi Yaliyotafsiriwa ya Shirika Hayakupatikana',
    org_video_not_found: 'Video Haikupatikana',
    canva: 'Fanya kwa Canva',
    canva_open: 'Bofya hapa kufungua mhariri wa Canva.',
    pdf: 'PDF',
    txt: 'MAANDISHI',
    human: 'Premium',
    shared_file: 'Faili yako imeshirikiwa kwa mafanikio.',
    error_shared_file:
      'Kuna tatizo katika kushiriki faili. Tafadhali jaribu tena.',
    publish: 'Chapisha',
    maze_scenes: 'Mandhari ya MetaMaze',
    pexel_images: 'Picha kutoka Pexel',
    group: 'Kundi',
    group_name: 'Jina la Kundi',
    select_group: 'Chagua Kundi',
    search_maze: 'Tafuta MetaMaze',
    hosts: 'Wenyeji',
    avg_score: 'Alama kwa Asilimia',
    maze_report: 'Ripoti ya Maze',
    maze_view: 'Muonekano wa Maze',
    title_maze: 'MetaMaze',
    author: 'Mwandishi',
    match: 'Ulinganifu wa Njia',
    preview_mazeTitle: 'Kichwa: ',
    other: 'Nyingine',
    total: 'JUMLA',
    report_course: 'KOZI',
    report_courses: 'KOZI',
    report_event: 'TUKIO',
    report_events: 'MATUKIO',
    report_maze: 'MAZE',
    report_personalize_learning: 'KUJIFUNZA KIBINAFSI',
    report_live_assessment: 'TATHMINI YA MOJA KWA MOJA',
    report_live_assessments: 'TATHMINI ZA MOJA KWA MOJA',
    report_skill_journey: 'SAFARI YA UJUZI',
    skill_journey: 'Safari ya Ujuzi',
    skill_journeys: 'Safari za Ujuzi',
    date: 'TAREHE: ',
    search_people: 'Tafuta Watu',
    passed: 'IMEFANIKIWA',
    failed: 'IMESHINDWA',
    item: 'KIPENGELE',
    type: 'AINA',
    minimum_pass_score: 'ALAMA YA CHINI YA KUPITA',
    resources_count: 'JUMLA YA RASILIMALI',
    back: 'NYUMA',
    resources: 'RASILIMALI',
    time_spent: 'MUDA ULIO TUMIKA (DAKIKA)',
    detail: 'MAELEZO',
    watched_time_mins: 'MUDA ULIOTAZAMWA (DAKIKA)',
    personalize_learning: 'Jifunze Kibinafsi',
    result: 'Matokeo',
    assessment_title: 'Kichwa',
    marketPlace_graph: 'Mchoro wa Marketplace',
    attachments: 'Viambatisho vya Ziada',
    new_scorm_course: 'Pakia Kozi Mpya ya SCORM',
    upload_scorm_course: 'Pakia Kozi ya SCORM',
    new_maze: 'Unda MetaMaze Mpya',
    new_skill_journey: 'Unda Safari ya Ujuzi',
    tags_scorm: 'SCORM',
    tags_skillJourney: 'Safari ya Ujuzi',
    new_discussion_room: 'Unda Podcast Mpya',
    title: 'Unataka kufanya nini leo?',
    build_course: 'Tengeneza Kozi Yangu',
    live_broadcast: 'Matangazo Mubashara',
    invite_users: 'Alika Watumiaji kwenye Shirika Langu',
    build_voice_over: 'Tengeneza Sauti Yangu',
    view_reports: 'Tazama Ripoti',
    upload_media: 'Pakia Vyombo vya Habari au Kazi na Ushiriki',
    main_menu: 'Menyu Kuu',
    get_started: 'ANZA',
    search_group: 'Tafuta Kikundi cha Shirika',
    ai_course: 'Kozi ya AI',
    search_user: 'Tafuta Jina la Kampuni',
    no_maze: 'Hakuna MetaMaze kwa sasa.',
    conference_event_title: 'Matukio ya Mkutano',
    conference_event_subTitle: 'Matukio ya Mkutano Yaliyokamilika',
    conference_event: 'Hakuna matukio ya mkutano kwa sasa.',
    no_skill: 'Hakuna safari za ujuzi kwa sasa.',
    no_podcast: 'Hakuna podcast kwa sasa.',
    maze_channel: 'MetaMaze',
    past_live_assessment: 'Tathmini za Zamani Mubashara',
    no_live_assessment: 'Hakuna tathmini mubashara kwa sasa.',
    enrolled_courses: 'Kozi',
    my_video_channel: 'Mikondo Yangu ya Video',
    enrolled_liveEvents: 'Matukio Mubashara',
    sharebot: 'Sharebot',
    selected_language: 'Lugha Iliyoteuliwa',
    shareSphere_game: 'Mchezo wa ShareSphere',
    maze: 'MetaMaze',
    skill: 'Safari ya Ujuzi',
    channel: 'Kituo',
    order: 'Agizo',
    is_record: 'Rekodi',
    no_maze_found: 'Hakuna MetaMaze iliyopatikana.',
    maze_self_limit_reached:
      'Kiwango cha tathmini binafsi cha MetaMaze kimefikiwa.',
    metamaze_two_times: 'Umeshafanya MetaMaze hii mara 2 tayari.',
    metamaze_two_times_no_result:
      'Umeshafanya MetaMaze hii mara 2. Matokeo yako hayatarekodiwa baada ya jaribio la tatu.',
    scorm_zip: 'SCORM ZIP',
    pass_score: 'Alama ya Chini ya Kupita',
    organization: 'Tafadhali Chagua Shirika',
    pass_score_mark: 'Tafadhali Weka Alama Kati ya 1 hadi 100',
    maze_cloning_success: 'MetaMaze "<0/>" imenakiliwa kwa mafanikio!',
    create_certificate: 'Tengeneza Cheti',
    create_badge: 'Tengeneza Beji',
    certificate_added: 'Cheti Kimeongezwa.',
    badge_added: 'Beji Imeongezwa.',
    certificate_warning: 'Huwezi hariri cheti/beji baada ya kuchapishwa!',
    created_course_plan:
      'Hariri na chapisha kozi yako iliyoundwa na panga matukio mubashara',
    market_place_space: 'Soko',
    select_course_language: 'Chagua lugha (Hiari)',
    select_language: 'Chagua lugha',
    file_upload: 'Pakia Faili',
    text: 'Andika maandishi hapa…',
    attempts_count: 'Idadi ya Majaribio Mtumiaji Anaweza Jaribu Tena',
    no_of_people_placeholder: 'Idadi ya Watu',
    back_to_maze: 'Rudi kwenye Mandhari ya MetaMaze',
    edit_maze: 'Hariri Maze',
    wait: 'Subiri...',
    retry: 'Jaribu Tena',
    publish_scorm_course: 'Chapisha Kozi Yako ya SCORM',
    publish_maze: 'Chapisha MetaMaze Yako',
    import: 'Ingiza Vipengele',
    answer_correct: 'Chagua Jibu Sahihi',
    author_name: 'Tafadhali Weka Jina la Mwandishi',
    select_category: 'Tafadhali Chagua Kategoria',
    course_outline: 'Tafadhali Weka Muhtasari wa Kozi',
    course_obj: 'Tafadhali Weka Malengo ya Kozi',
    course_description: 'Tafadhali Weka Maelezo ya Kozi',
    maze_outline: 'Tafadhali Weka Muhtasari wa Maze',
    maze_obj: 'Tafadhali Weka Malengo ya Maze',
    maze_description: 'Tafadhali Weka Maelezo ya Maze',
    lessons: 'Tafadhali Weka Idadi ya Somo',
    user_email_require: 'Barua Pepe ya Mtumiaji Inahitajika',
    team_size: 'Ukubwa wa Timu Unahitajika',
    enter_price: 'Tafadhali Weka Bei (5 au Zaidi)',
    input_title_maze: 'Tafadhali Weka Kichwa cha Maze',
    trainer_bio: 'Tafadhali Weka Wasifu wa Mwalimu',
    trainer_linkedin: 'Tafadhali Weka Kiungo cha LinkedIn cha Mwalimu',
    error_video: 'Tafadhali Weka Idadi ya Video',
    input_video_link: 'Tafadhali Weka Kiungo cha Video',
    number_of_video: 'idadi ya video',
    number_of_lessions: 'idadi ya masomo',
    no_of_people_in_conference: 'Watu wangapi wapo kwenye mkutano?',
    transcribe_settings: 'Mipangilio ya Kunakili',
    transcribe: 'Nakili',
    cloning_maze: 'Inakili MetaMaze...',
    id_number: 'Nambari ya Kitambulisho',
    timezone: 'Eneo la Saa',
    edit_maze: 'Hariri',
    delete_maze: 'Futa',
    view_maze: 'Tazama',
    create_metamaze: 'Tengeneza MetaMaze',
    metamaze_scenario: 'Hali ya MetaMaze',
    publish_metamaze: 'Mipangilio ya Kuchapisha',
    search_result: 'Matokeo ya Utafutaji:',
    search_for: 'Tafuta',
    search_no_result: '- Hakuna matokeo yanayopatikana!',
    channel_no_available: 'Hakuna kituo kinachopatikana!',
    this_card: 'Hii ni kadi',
    course_no_available: 'Hakuna kozi zinapatikana!',
    exit_fullscreen: 'Toka Skrini Nzima',
    bg_image: 'Picha ya Mandharinyuma',
    introduction: 'Utangulizi',
    summary: 'Muhtasari',
    generate_introduction: 'Tengeneza Utangulizi',
    generate_summary: 'Tengeneza Muhtasari',
    bullet_points: 'Vidokezo Muhimu',
    title_simulation: 'Tafadhali Weka Jina la Kuigiza',
    view_generated_images: 'Tazama Picha Zilizotengenezwa',
    image_transparency: 'Uwazi wa Picha',
    template_bg_color: 'Rangi ya Mandharinyuma ya Kiolezo',
    select_template_layout: 'Chagua Mpangilio wa Kiolezo',
    reload_template: '(Pakua upya violezo)',
    are_you_sure_want_close: 'Una uhakika unataka kufunga?',
    all_your_changes_will_be_lost: 'Mabadiliko yako yote yatapotea.',
    please_checked_before_generated_video:
      'Tafadhali hakikisha masharti yote yamekamilika kabla ya kutengeneza video.',
    voice_must_be_selected: 'Sauti lazima ichaguliwe',
    avatar_must_be_selected: 'Picha ya avatar lazima ichaguliwe.',
    maximum_five_slides_try_again:
      'Hitilafu katika kutoa picha kutoka kwa faili yako. Hakikisha kuna slaidi zisizozidi 5 na kila moja ina maelezo. Tafadhali Jaribu Tena!',
    back_to_upload: 'Rudi Kupakia',
    uploading_file_to_server: 'Inapakia faili kwenye seva',
    extracting_images_from_your_file: 'Inatoa picha kutoka kwa faili yako',
    upload_your_ppt_or_drag:
      'Pakia faili yako ya uwasilishaji (.PPTX) au ivute hapa.',
    maximum_five_slides_error:
      'Hakikisha faili ya PowerPoint ina slaidi zisizozidi 5 na kuna maelezo katika kila slaidi. Vinginevyo, kutakuwa na hitilafu.',
    number_of_questions_generated: 'Idadi ya Maswali Yanayotakiwa Kutengenezwa',
    quiz_page_this_cannot_be_done:
      'Una uhakika unataka kuongeza jaribio kwenye ukurasa huu? Hili haliwezi kutenduliwa.',
    confirm_selection: 'Thibitisha Uchaguzi',
    select_quiz_page: 'Chagua Ukurasa wa Jaribio',
    lesson_do_you_want_add_this_quiz:
      'Unataka kuongeza jaribio hili katika sehemu gani ya somo?',
    beginning_of_lesson: 'Mwanzoni mwa Somo',
    end_of_lesson: 'Mwisho wa Somo',
    currently_active_page: 'Ukurasa Unaotumika Sasa',
    finish: 'Maliza',
    upload_selection_file: 'Pakia Faili ya Sehemu',
    general_quiz: 'Jaribio la Kawaida',
    manage_sequence: 'Dhibiti Mlolongo',
    save_sequence: 'Hifadhi Mlolongo',
    new: 'Mpya',
    in_progress: 'Inaendelea',
    recommended_course: 'Kozi Iliyopendekezwa',
    up_coming: 'Ijayo',
    past_live: 'Vipindi Vilivyopita',
    input_your_channel_name: 'Tafadhali weka jina la Kituo chako!',
    organization_place: 'Soko la Shirika',
    marketplace_report: 'Ripoti ya Soko',
    story_writing: 'Uandishi wa Hadithi',
    Ai_quiz: 'Jaribio la Akili Bandia',
    generate_quiz: 'Tengeneza Jaribio',
    create_story: 'Tunga Hadithi',
    change_layout_page: 'Unakaribia kubadilisha mpangilio wa ukurasa huu.',
    change_layout_message:
      'Tafadhali kumbuka kuwa maandishi, picha, mandharinyuma na nembo tu ndivyo vitahifadhiwa. Vipengele vingine vyote vitaondolewa.',
    reviews: 'Maoni',
    tab_attachments: 'Viambatisho',
    zoom_in: 'Kuza',
    zoom_out: 'Punguza',
    zoom_reset: 'Weka Upya Kuza',
    no_attachment: 'Hakuna viambatisho.',
    select_upload_simulation: 'Tafadhali chagua/pakia majaribio.',
    quiz_updated_successfully: 'Jaribio limesasishwa kwa mafanikio!',
    quizes: 'Majaribio',
    trivia: 'Maswali ya Kupima Maarifa',
    closing: 'Inafunga...',
    products: 'Bidhaa',
    ask_questions: 'Uliza swali hapa...',
    course_information: 'Taarifa ya Kozi',
    course_assistance: 'Msaada kwa Muundaji wa Kozi',
    go_back: 'Rudi Nyuma',
    ai_generate_content_progress: 'Inazalisha Maudhui...',
    view_generate_content: 'Tazama Maudhui Yaliyotengenezwa',
    generate_error: 'Hitilafu ya Uzalishaji!',
    confirm_creating_course:
      'Unataka kuthibitisha kuunda kozi kwa kutumia maudhui haya?',
    generate_content_automatically:
      'Hii itaongeza maudhui yote yaliyotengenezwa moja kwa moja kama masomo na kurasa kwenye kozi yako.',
    quiz_created_successfully: 'Jaribio limeundwa kwa mafanikio!',
    create_quiz: 'Unda Jaribio',
    quiz_setting: 'Mipangilio ya Jaribio',
    please_fill_quiz_setting:
      '* Tafadhali jaza sehemu zote za Mipangilio ya Jaribio',
    question_list: 'Orodha ya Maswali',
    add_quiz_to_page: 'Ongeza Jaribio kwenye Ukurasa',
    form_create_question: 'Fomu ya Kuunda Swali',
    user_information_updated: 'Taarifa za Mtumiaji zimesasishwa!',
    your_stripe_activete_to_continue:
      'Akaunti yako ya Stripe haijawashwa. Tafadhali iunganishe au iwashe ili kuendelea.',
    connect_tripe: 'Unganisha Stripe',
    certificate_sent_sucessfully:
      'Cheti kimepelekwa kwenye barua pepe yako kwa mafanikio.',
    error_try_again: 'Hitilafu. Jaribu tena!',
    error_delete_channel: 'Hitilafu kufuta kituo.',
    error_update_sub: 'Hitilafu kusasisha usajili.',
    end_time_cannot_start:
      'Muda wa kumaliza hauwezi kuwa kabla ya muda wa kuanza.',
    start_date_time_interval: 'Tarehe na muda wa kuanza vinahitajika!',
    podcast_updated_successful: 'Podikasti imesasishwa kwa mafanikio.',
    podcast_created_successful: 'Podikasti imeundwa kwa mafanikio.',
    podcast_published_successful: 'Podikasti imechapishwa kwa mafanikio.',
    podcast_cover_updated: 'Jalada la podikasti limesasishwa.',
    new_podcast_details:
      'Podikasti mpya itaundwa kwa kutumia maelezo mapya yaliyoingizwa.',
    current_update_podcast: 'Sasisha podikasti ya sasa, muziki na hadithi.',
    create_new_podcast: 'Unda Podikasti Mpya',
    publish_podcast_public_view: 'Chapisha podikasti kwa mtazamo wa umma.',
    only_allowed_twenty_five_email: 'Barua pepe 25 tu zinaruhusiwa.',
    only_allowed_five_email: 'Barua pepe 5 tu zinaruhusiwa.',
    cover_is_required: 'Jalada linahitajika.',
    topic_is_required: 'Mada inahitajika.',
    delete_schedule: 'Futa Ratiba',
    make_as_coaching: 'Weka kama Upatikanaji wa Mafunzo',
    manage_category: 'Dhibiti Aina',
    threshold: 'Kizingiti',
    threshold_popup:
      'Thamani ya asilimia (%) ambayo huanzisha mapendekezo kwa aina husika.',
    list_of_catagory: 'Orodha ya Aina',
    category_name: 'Jina la Aina',
    category_threshold: 'Kizingiti cha Aina',
    play_game: 'Cheza Mchezo',
    switching_organization: 'Inabadilisha Shirika...',
    coaching_session: 'Kikao cha Mafunzo',
    required_channel_id: 'ID ya Kituo inahitajika!',
    error_occured_try_again: 'Hitilafu imetokea. Jaribu tena!',
    please_complete_marketplace_form: 'Tafadhali kamilisha fomu ya soko!',
    upload_file_corrupt: 'Faili iliyopakiwa imeharibika.',
    course_not_published: 'Kozi haijachapishwa bado!',
    error_request: 'Hitilafu kwenye ombi. Tafadhali jaribu tena!',
    skill_request: 'Tafadhali jaza sehemu zinazokosekana!',
    error_occured: 'Hitilafu imetokea. Jaribu tena!',
    show_time: 'Onyesha Muda',
    start_time: 'Muda wa Kuanza',
    end_time: 'Muda wa Kumaliza',
    room_name: 'Jina la Podikasti',
    add_guest_speaker: 'Ongeza Mzungumzaji Mwalikwa',
    cover_picture: 'Picha ya Jalada',
    guest_speaker: 'Mzungumzaji Mwalikwa',
    see_more: 'Tazama Zaidi',
    see_less: 'Tazama Chache',
    background: 'Mandharinyuma',
    icon: 'Aikoni',
    icon_size: 'Ukubwa wa Aikoni',
    icon_color: 'Rangi ya Aikoni',
    only_text: 'Maandishi Pekee',
    change_bg: 'Badilisha Rangi ya Mandharinyuma',
    bg_color: 'Rangi ya Mandharinyuma',
    font_size: 'Ukubwa wa Herufi',
    normal: 'Kawaida',
    change_color: 'Badilisha Rangi ya Maandishi',
    slant_text: 'Andika kwa Mwinuko',
    text_radius: 'Radi ya Maandishi',
    vertical_align: 'Mpangilio Wima',
    horizontal_align: 'Mpangilio Wima',
    change_icon_color: 'Badilisha Rangi ya Aikoni',
    upload_icon: 'Pakia Aikoni',
    upload_signature: 'Pakia Sahihi',
    add_another_sign: 'Ongeza Sahihi Nyingine',
    name_badges: 'Jina la Beji',
    should_less_150: 'inapaswa kuwa herufi 150 au chini',
    your_badge: 'Beji Yako',
    do_you_want_delete_badge: 'Una uhakika unataka kufuta beji hii?',
    do_you_want_delete_cert: 'Una uhakika unataka kufuta cheti hiki?',
    upload_logo: 'Pakia Nembo',
    name_of_cert: 'Jina la Cheti',
    upload_cert: 'Sasisha Cheti',
    your_cert: 'Cheti Chako',
    translate_to: 'Tafsiri hadi',
    select_file_attach: 'Chagua Faili ya Kuweka',
    certificate: 'Cheti',
    badge: 'Beji',
    publish_options: 'Chaguo za Kuchapisha',
    publish_skills_journey: 'Chapisha Safari ya Ujuzi',
    videos: 'Video',
    generate_ai_video:
      'Mchakato wa kuzalisha video unaweza kuchukua muda. Utaarifiwa kwa barua pepe baada ya kukamilika.',
    trainer_information: 'Taarifa za Mwezeshaji',
    promotional_video_link: 'Kiungo cha Video ya Uendelezaji',
    please_select: 'Tafadhali chagua',
    image_name: 'Jina la Picha:',
    image_size: 'Ukubwa wa Picha:',
    charecters_fifteen_less: 'Herufi 15 au chini',
    leadership: 'Uongozi',
    text_arc: 'Mviringo wa Maandishi',
    vertical: 'Wima',
    horizontal: 'Mlalo',
    badge_history: 'Historia ya Beji',
    templates: 'Violezo',
    sign: 'Sahihi',
    logo: 'Nembo',
    certificate_history: 'Historia ya Vyeti',
    please_wait: 'Tafadhali Subiri...',
    information: 'Taarifa',
    support_five_thousand_live_event:
      'Inasaidia hadi washiriki 5000 kwa tukio la moja kwa moja',
    support_ten_live_event:
      'Inasaidia hadi washiriki 10 wa video ya moja kwa moja',
    we_will_back_participant:
      'Tutarejea na tukio lenye uwezo wa kuwakaribisha washiriki wengi.',
    course_objectives: 'Malengo ya Kozi',
    course_outlines: 'Muhtasari wa Kozi',
    price_dollor: 'bei (USD)',
    not_completed: 'Haijakamilika',
    enable_marketplace: 'Wezesha Soko',
    enable_course_ai: 'Wezesha Kuunda Kozi kwa AI',
    enable_report_to_admin: 'Wezesha Ripoti kwa Msimamizi',
    enable_white_label: 'Wezesha Alama Nyeupe',
    enable_eleven_labs_for_maze_play: 'Wezesha Elevenlabs kwa Maze Play',
    enable_eleven_labs_for_maze_play_cloned:
      'Wezesha Sauti Iliyoklonishwa ya Elevenlabs',
    simulation_quiz: 'Jaribio la Kuiga',
    bg_color_setting: 'Mipangilio ya Rangi ya Mandharinyuma',
    color_preview: 'Onyesho la Awali la Rangi',
    choose_new_color: 'Chagua Rangi Mpya',
    remove_color: 'Ondoa Rangi',
    apply_color: 'Tumia Rangi',
    elemeent_in_a_sceenario_page:
      'Huwezi kuongeza kipengele kingine kwenye ukurasa wa hali halisi. Tafadhali jaribu ukurasa mwingine au ondoa hali halisi kwanza.',
    no_data_found: 'Hakuna Data Iliyopatikana.',
    references: 'Marejeleo',
    open_file: 'Fungua Faili',
    showing_result: 'Inaonyesha Matokeo:',
    fiften_day_free_trail: 'Jaribio la Siku 15 Bila Malipo',
    your_browser_does_not_support:
      'Kivinjari chako hakiungi mkono kipengele cha sauti.',
    podcast_desc: 'Maelezo ya Podikasti',
    input_podcast_desc: 'Tafadhali weka maelezo ya podikasti',
    podcast_obj: 'Malengo ya Podikasti',
    input_podcast_obj: 'Tafadhali weka malengo ya podikasti',
    podcast_outline: 'Muhtasari wa Podikasti',
    input_podcast_outline: 'Tafadhali weka muhtasari wa podikasti',
    add_file: 'Ongeza Faili',
    generate_podcast_audio: 'Tengeneza Sauti ya Podikasti',
    generate_uploaded_file_input_parameter:
      'Inatengeneza maudhui yanayohusiana na faili zilizopakiwa na vigezo vilivyowekwa.',
    go_backe_generation_state: 'Rudi kwenye hali ya kutengeneza maudhui.',
    create_ai_powered_podcast:
      'Unda kipindi cha podikasti chenye nguvu ya AI kilicho na sauti iliyotengenezwa.',
    generate_voice_for_all_podcast:
      'Tafadhali tengeneza sauti kwa vipindi vyote vya podikasti',
    create_podcast_episode: 'Unda Kipindi cha Podikasti',
    voice_name: 'Jina la Sauti',
    input_custom_name: 'Tafadhali weka jina maalum!',
    enter_custom_name: 'Weka jina la sauti maalum',
    upload_complete: 'Upakiaji umekamilika',
    uploading_in_progress: 'Inapakia...',
    podcast_stream_content: 'Maudhui ya Matangazo ya Podikasti',
    upload_podcast_cover: 'Tafadhali pakia jalada la podikasti!',
    enter_podcast_name: 'Tafadhali weka jina la podikasti!',
    podcast_topic: 'Mada ya Podikasti',
    enter_podcast_topic: 'Tafadhali weka mada ya podikasti!',
    enter_podcast_desc: 'Tafadhali weka maelezo ya podikasti!',
    number_of_speaker: 'Idadi ya Wasemaji',
    select_the_number_of_speaker: 'Tafadhali chagua idadi ya wasemaji!',
    number_of_episode: 'Idadi ya Vipindi',
    input_number_of_episode: 'Tafadhali weka idadi ya vipindi!',
    podcast_length: 'Urefu wa Podikasti',
    select_the_podcast_length: 'Tafadhali chagua urefu wa podikasti!',
    short_podcast: 'Fupi (dakika 5-10)',
    medium_podcast: 'Wastani (dakika 15-18)',
    long_podcast: 'Ndefu (dakika 18+)',
    name_of_host: 'Jina la Mtangazaji',
    enter_host_name: 'Tafadhali weka jina la mtangazaji!',
    guest_name: 'Majina ya Wageni',
    enter_guest_name: 'Tafadhali weka jina la mgeni!',
    choose_speaker_tone: 'Chagua mtindo wa mzungumzaji',
    enter_speaker_tone: 'Tafadhali chagua mtindo wa podikasti!',
    informal: 'Isiyo rasmi',
    formal: 'Rasmi',
    serious: 'Kikali',
    light_humor: 'Mzaha Mpole',
    casual: 'Kawaida',
    select_content_source: 'Chagua Chanzo cha Maudhui',
    from_internet: 'Kutoka Intaneti',
    upload_pdf_internet: 'Pakia PDF au Hati ya Ndani',
    note: 'Kumbuka:',
    podcast_content_will_be_automatically_generated:
      'Maudhui ya podikasti yatatengenezwa kiotomatiki kwa kutumia vyanzo vya kuaminika vya mtandaoni.',
    upload_or_select_file: 'Tafadhali pakia au chagua faili!',
    podcast_eposode_title: 'Kichwa cha Kipindi cha Podikasti',
    enter_podcast_title: 'Tafadhali weka kichwa cha kipindi!',
    podcast_episode_des: 'Maelezo ya Kipindi cha Podikasti',
    enter_podcast_episode_des: 'Tafadhali weka maelezo ya kipindi!',
    voice: 'Sauti',
    music: 'Muziki',
    select_music: 'Chagua muziki',
    play_the_music: 'Cheza muziki',
    stop_the_music: 'Simamisha muziki',
    context: 'Muktadha',
    generate_audio_content_selected_voice:
      'Hii itatengeneza sauti ya maudhui kulingana na sauti zilizochaguliwa.',
    required_field_before_submitting:
      'Tafadhali jaza sehemu zote zinazohitajika kabla ya kutuma.',
    regenerate_voice: 'Tengeneza Sauti Tena',
    generate_voice: 'Tengeneza Sauti',
    your_browser_does_not_suppot:
      'Kivinjari chako hakitumii kipengele cha sauti.',
    are_sure_leave_podcast: 'Una uhakika unataka kuondoka kwenye podikasti?',
    broadcast_ongoing:
      'Matangazo yanaendelea. Je, unataka kuondoka kwenye ukurasa huu kweli?',
    brodcaster_unavailable: 'Mtangazaji hayupo kwa sasa.',
    setting_calender_for_booking: 'Inasanidi Kalenda kwa Ajili ya Uhifadhi',
    add_calender: 'Ongeza Kalenda',
    waiting_join_host: 'Inasubiri mtangazaji kujiunga...',
    no_reviews_found: 'Hakuna maoni yaliyopatikana.',
    rated_already: 'Umeshatoa alama kwa tukio hili la moja kwa moja.',
    downlink_png: 'pakua_png',
    downlink_jpg: 'pakua_jpg',
    donwload_file_format: 'Tafadhali chagua aina ya faili unayotaka kupakua.',
    crashed_event:
      'Tukio hili limeharibika. Unahitaji kuunda tukio jipya. Samahani kwa usumbufu.',
    prompt: 'Amri:',
    generated_image: '🚀 Inatengeneza picha yako... Tafadhali subiri.',
    download_add: 'Pakua zote',
    setting_generator: 'Mpangilio wa Jenereta',
    enter_image_prompt: 'Tafadhali weka amri ya picha',
    image_prompt: 'Weka amri yako ya picha',
    negative_prompt: 'Amri hasi',
    negative_image_prompt: 'Weka amri hasi ya picha',
    number_output: 'Idadi ya Matokeo',
    enter_number_output: 'Weka idadi ya matokeo',
    image_style: 'Tafadhali chagua mtindo wa picha',
    output_format: 'Aina ya Matokeo',
    seeds: 'Mbegu',
    enter_seeds: 'Weka idadi ya mbegu',
    performance_mode: 'Hali ya Utendaji',
    quality: 'Ubora',
    speed: 'Kasi',
    balanced: 'Imesawazishwa',
    guidance_scale: 'Kiwango cha Mwongozo',
    enter_guidance: 'Weka kiwango cha mwongozo',
    select_image: 'Tafadhali chagua picha.',
    image_prmt: 'Amri ya Picha',
    generate_image_list_empty: 'Orodha ya picha zilizotengenezwa ni tupu.',
    knowledge_center_tooltrip_des:
      'Pata majibu mafupi na sahihi kwa maswali mbalimbali, yakiwemo ya maarifa ya jumla. Majibu haya hutolewa na mfano wa AI uliofunzwa kwa maandishi mbalimbali kutoka mtandaoni.',
    contexts: 'Muktadha',
    ai_processing_video_sharebot:
      'Usindikaji wa video kwa kutumia AI utachukua takribani saa 24 kukamilika na kuonyeshwa kwenye Sharebot.',
    remove_sharebot_video:
      'Kama unataka kuondoa rejeleo la video kwenye Sharebot, tafadhali futa pia manukuu sambamba na video hiyo.',
    remove_sharebot_video_audio:
      'Kufuta manukuu kutafuta rejeleo la video/sauti kwenye Sharebot, lakini video itaendelea kuonekana kwenye maktaba/kituo cha media.',
    monthly_live_stream:
      'Ili kubadilisha kikomo chako cha kila mwezi cha matangazo ya moja kwa moja tafadhali wasiliana na',
    monthly_transcribe_limit:
      'Ili kubadilisha kikomo chako cha kila mwezi cha kutafsiri tafadhali wasiliana na',
    must_be_one_to_three_hundred: 'Lazima iwe kati ya dakika 1 hadi 300.',
    all_field_required: 'Sehemu zote zinahitajika.',
    duration_minute: 'Muda (dakika 300 kwa zaidi)',
    gender: 'Jinsia',
    select_gender: 'Chagua Jinsia',
    accent: 'Lahaja',
    select_accent: 'Chagua Lahaja',
    create_voice: 'Unda Sauti',
    enter_voice_name: 'Weka Jina la Sauti',
    select_voice_gender: 'Tafadhali chagua jinsia ya sauti',
    upload_voice: 'Pakia Sauti Yako',
    upload_voice_mp_three: 'Pakia sauti yako (.mp3)',
    cloned_voice: 'Sauti Zilizoklonishwa',
    voice_type: 'Aina ya Sauti',
    select_voice_type: 'Chagua Aina ya Sauti',
    sharelook_stand: 'Kawaida',
    sharelook_premium: 'Premium',
    sharelook_custum_voice: 'Maalum (Uklonishaji Sauti)',
    create_auto_flow: 'Unda mtiririko wa kiotomatiki',
    how_many_layers: 'Tabaka ngapi',
    verify_selection: 'Thibitisha Uchaguzi',
    uploaded_successful: 'Imepakiwa kwa mafanikio',
    upload_failed: 'Imeshindikana kupakia',
    upload_only_five_mb: 'Pakia Maudhui (Faili za PDF, max 5)',
    docs_from_org_library: 'Tumia Hati kutoka Maktaba ya Shirika',
    failed_maze_generate:
      'Imeshindikana kutengeneza maze. Tafadhali jaribu tena.',
    generate_metamaze: 'Inatengeneza MetaMaze...',
    metamaze_being_generated:
      'MetaMaze yako inatengenezwa. Utajulishwa kupitia barua pepe mara tu itakapokamilika.',
    metamaze_generate_successfully: 'MetaMaze Imekamilika Kwa Mafanikio!',
    metamaze_with_proceed: 'Sasa unaweza kuendelea na MetaMaze.',
    ai_metamaze_generate: 'Uundaji wa MetaMaze kwa AI',
    what_kind_maze_create: 'Ungependa kuunda aina gani ya maze?',
    manual_metamaze_creation: 'Uundaji wa MetaMaze kwa Mkono',
    manually_maze_customizing_scnario:
      'Unda maze kwa mkono kwa kubinafsisha hali na chaguo',
    maze_ai_generated: 'Unda maze kiotomatiki kwa kutumia AI',
    unmark_deadend: 'Ondoa alama ya mwisho',
    mark_deadend: 'Weka alama ya mwisho',
    select_multiple_image_for_scenario:
      'Unaweza kuchagua picha nyingi kwa ajili ya hali.',
    select_your_image: 'Picha zako ulizochagua',
    click_to_preview: 'Bonyeza ili kuona hakikisho',
    are_you_sure_delete_image: 'Una uhakika unataka kufuta picha hii?',
    select_image_from_library:
      'Chagua Picha kutoka Maktaba ya Vyombo vya Habari',
    uploading_video: 'Inapakia video...',
    tree_node_type: 'Aina ya Kifurushi cha Mti',
    correct_option_scenario: 'Chaguo Sahihi au Hali',
    incorrect_option: 'Chaguo Lisilo Sahihi',
    option_scenario_without_text: 'Chaguo au Hali bila maandishi yoyote',
    dead_end: 'Mwisho (Mpaka Mwekundu)',
    correct_path: 'Njia Sahihi',
    incorrect_path_not_selected_correct_option_path:
      'Njia Isiyo Sahihi / Njia ambapo chaguo sahihi halijachaguliwa.',
    double_click_on_tree_node:
      'Unapobofya mara mbili kwenye kifurushi cha mti, mhariri wa maandishi utasogeza kiotomatiki kuonyesha maudhui ya kifurushi hicho.',
    add_scenario: 'Ongeza Hali',
    add_option: 'Ongeza Chaguo',
    an_error_occured: 'Hitilafu imetokea:',
    download_summary: 'Pakua Muhtasari',
    step_wise_analysis: 'Uchambuzi Hatua kwa Hatua',
    step: 'Hatua',
    upload_csv_file: 'Pakia Faili ya CSV',
    download_template_to_import: 'Pakua kiolezo cha mfano kuingiza',
    please_input_email: 'Tafadhali weka barua pepe.',
    email_at_least_three_characters:
      'Barua pepe lazima iwe na angalau herufi 3.',
    email_cannot_be_empty: 'Barua pepe haiwezi kuwa tupu.',
    input_email_in_new_line:
      'Tafadhali weka barua pepe (kila moja kwenye mstari mpya)',
    role: 'Jukumu',
    select_role: 'Tafadhali chagua Jukumu',
    select_group: 'Tafadhali chagua Kikundi',
    identification_number: 'Nambari ya Utambulisho (Hiari)',
    add_identification_number: 'Tafadhali ongeza Nambari ya Utambulisho',
    pie_chart_of_all_categories:
      'Chati ya mviringo ya makundi yote kulingana na matumizi yao kwenye Sharelook.',
    total_sharesphere_question_answered_by_users:
      'Jumla ya maswali ya ShareSphere yaliyojibiwa na watumiaji wa shirika hili, pamoja na makundi yao na mafanikio au kushindwa.',
    voice_style_over_the_text: `Unaweza kutumia mitindo mingi ya sauti juu ya maandishi unayoandika bla bla bla. Lorem Ipsum ni maandishi bandia ya kuchapisha na kuchapisha.`,
    input_your_question: 'Tafadhali weka swali lako!',
    make_me_sales_manager: 'mf: Nini kinaweza kunifanya kuwa meneja wa mauzo',
    enter_the_number_relevant_document: 'Weka idadi ya hati husika',
    please_wait_loading_result: 'Tafadhali subiri, matokeo yanapakiwa...',
    no_result_found:
      'Hakuna matokeo yaliyopatikana. Jaribu kuuliza maswali zaidi',
    browser_doesnot_support_iframes: 'Kivinjari chako hakihimili iframes',
    total_duration: 'Muda Jumla',
    number_of_messages: 'Idadi ya Ujumbe',
    search_result: 'Matokeo ya Utafutaji',
    count_result: '(matokeo 1244)',
    your_other_interests: 'Maslahi yako mengine',
    your_total_score: 'Alama Yako Jumla',
    add_a_question: '+ongeza swali',
    travia_question_empty: 'Orodha ya maswali ya Travia ni tupu.',
    video_generation_is_on_queue: 'Uundaji wa video yako uko kwenye foleni!',
    checking_video_status: 'Inakagua hali ya video...',
    total_quizzes: 'Jaribio Jumla',
    number_of_votes: 'Idadi ya Kura',
    total_events: 'Matukio Jumla',
    number_of_rates: 'Idadi ya Viwango',
    number_of_likes: 'Idadi ya Mapendeleo',
    all_courses: 'Kozi Zote',
    total_questions: 'Maswali Jumla',
    no_skill_journey: 'Hakuna safari ya ujuzi iliyopo!',
    search_no_results: '- hakuna matokeo yaliyopatikana!',
    no_image_generated: 'Hakuna Picha Iliyoundwa!',
    all_topic_in_this_lesson:
      'Mada zote katika somo hili zitafutwa. Hili haliwezi kurejeshwa.',
    content_has_been_generated: 'Maudhui yameundwa kwa mada hii.',
    update_course_template: 'Sasisha Kiolezo cha Kozi',
    add_course_template: 'Ongeza Kiolezo cha Kozi',
    create_course_now: 'Unda Kozi Sasa',
    preview_course: 'Onyesha Kozi',
    layout: 'Mpangilio',
    import_from_youtube: 'Ingiza kutoka Youtube',
    my_media_library: 'Maktaba Yangu ya Vyombo vya Habari',
    bg_added: 'Mandharinyuma imeongezwa',
    add_bg: 'Ongeza Mandharinyuma',
    booked_schedule: 'Ratiba Iliyowekwa',
    add_schedule: 'Ongeza Ratiba',
    are_you_delete_schedule: 'Una uhakika unataka kufuta ratiba hii?',
    add_task: 'Ongeza Kazi',
    update_calender: 'Sasisha Kalenda',
    manage_cookies: 'Simamia Vitu Vidogo (Cookies)',
    cookie_banner_text:
      'Tunatumia cookies kuboresha uzoefu wako wa kuvinjari, kuchambua trafiki ya wavuti, na kubinafsisha maudhui. Faragha yako ni muhimu kwetu.',
    accept_all_cookies: 'Kubali Cookies Zote',
    reject_all: 'Kataa Zote',
    customize: 'Tengeneza',
    cookie_preferences_title: 'Mapendeleo ya Cookies na Mipangilio ya Faragha',
    privacy_subtitle:
      'Faragha yako ni muhimu kwetu. Chagua ni cookies gani unayokubali. Unaweza kubadilisha mipangilio hii wakati wowote.',
    save_choices: 'Hifadhi Chaguo Zangu',
    strictly_necessary: 'Muhimu Kihalisi',
    strictly_necessary_desc:
      'Cookies hizi ni muhimu ili tovuti ifanye kazi ipasavyo. Zinawezesha kazi za msingi kama urambazaji wa kurasa, kuwasilisha fomu, na kupata maeneo salama. Tovuti haiwezi kufanya kazi vizuri bila hizi cookies.',
    analytics_performance: 'Uchambuzi na Utendaji',
    analytics_performance_desc:
      'Cookies hizi zinatusaidia kuelewa jinsi wageni wanavyoshirikiana na tovuti yetu kwa kukusanya na kuripoti taarifa bila kujulikana. Hii inasaidia kuboresha utendaji wa tovuti na uzoefu wa mtumiaji.',
    advertising_marketing: 'Matangazo na Masoko',
    advertising_marketing_desc:
      'Cookies hizi zinatumika kufanya ujumbe wa matangazo uwe sahihi zaidi kwako. Zinazuia tangazo moja kurudiarudi mara nyingi na kuhakikisha matangazo yanaonyeshwa kwa usahihi kwa wauzaji.',
    tracking_social: 'Ufuatiliaji na Mitandao ya Kijamii',
    tracking_social_desc:
      'Cookies hizi zinaruhusu utendaji ulioboreshwa na kubinafsishwa, kama vile vipengele vya mitandao ya kijamii na maudhui binafsi. Zinaweza kuwekwa na sisi au watoa huduma wa tatu.',
    functional: 'Kazi Zaidi',
    functional_desc:
      'Cookies hizi zinaruhusu utendaji ulioimarishwa kama vile msaada wa chat, msaada wa moja kwa moja, na vipengele vingine vya ushirikiano vinavyoboreshwa uzoefu wako wa tovuti.',
    your_rights: 'Haki Zako:',
    rights_description:
      'Unaweza kuvuta ridhaa yako wakati wowote, kupata data zako, au kuomba ifutwe wakati wowote.',
    withdraw_consent: 'Vuta Ridhaa Zote',

    how_many_options: 'Chaguzi Ngapi',
    add_content: 'Ongeza Yaliyomo',
    downloads_center: 'Kituo cha Upakuaji',
    sharelook_help_center: 'Kituo cha Msaada cha Sharelook',
    channel_outline: 'Muhtasari wa Kituo',
    channel_objectives: 'Malengo ya Kituo',
    no_sop_available: 'Hakuna orodha ya SOP inapatikana.',
    generate_world_summary: 'Tengeneza Hali',
    world_scenario: 'Hali Halisi ya Dunia',
    drag_icon_hint: 'Ushauri: Vuta ikoni kwenye kijiandiko ili kuipanga',
    drag_text_hint: 'Ushauri: Vuta maandishi kwenye kijiandiko ili kuipanga',
    edit_badge: 'Hariri Bango',
    create_new_badge: 'Bango Jipya',
    select_video_preview: 'Chagua video kwa mapema',
    certificate_title_required: 'Kichwa cha Cheti kinahitajika',
    discard_changes: 'Tupa Mabadiliko',
    edit_certificate: 'Hariri Cheti',
    add_another_logo: 'Ongeza Logo Nyingine',
    optional: 'Hiari',
    doc: 'DOC',
    ppt: 'PPT',
    quest_title: 'Tengeneza Shida Mpya',
    quest_filter_title: 'Shida',
    sharelook_assistance: 'Msaada wa Sharelook',
    upload_scorm_zip: 'Pakia SCORM Zip',
    only_letters_numbers_space_dot_allowed:
      'Herufi, namba, nafasi, na nukta pekee zinaruhusiwa!',
    video_playing: 'Inaendelea',
    course_price_message:
      '*Kozi itachapishwa kwa watumiaji ndani ya shirika tu na haiwezi kuuzwa sokoni.',
    lesson_must_be_positive: 'Idadi ya Masomo lazima iwe zaidi ya 1',
    btn_proceed: 'Endelea',
    rule_select_music: 'Tafadhali chagua muziki',
    course_info: 'Taarifa za Kozi',
    content_selection: 'Chaguo la Maudhui',
    course_content_source: 'Chanzo cha Maudhui ya Kozi',
    choose_how_to_source: 'Chagua jinsi ya kupata maudhui kwa kozi hii:',
    automatic_selection: 'Chaguo la Kiotomatiki',
    system_will_automatically_select_relavant_documents:
      'Mfumo utachagua nyaraka zinazofaa kiotomatiki kutoka maktaba yako',
    manual_selection: 'Chaguo la Mkono',
    choose_specific_documents_from_your_library:
      'Chagua nyaraka maalum kutoka maktaba yako',
    upload_files: 'Pakia Faili',
    upload_new_documents:
      'Pakia nyaraka mpya (PDF, DOC, DOCX, PPT, PPTX, TXT) - Faili 5 pekee',
    file: 'faili',
    ready_to_upload: 'tayari kupakia',
    clear_all: 'Futa Zote',
    confirm_course_wide_premiew: 'Thibitisha Mapema ya Kozi Yote',
    generate_course_preview: 'Tengeneza Mapema ya Kozi',
    instructions_across_the_course_to_generate:
      'Tutatumia maagizo yako kwenye kozi yote ili kutengeneza mapema. Kagua kila kitu kwanza, kisha uamue kuhifadhi au kutupilia mbali mabadiliko.',
    instruction_to_preview_course_wide: 'Maagizo ya mapema ya kozi yote:',
    edit_content: 'Hariri Yaliyomo',
    manage_course_template: 'Simamia Kiolezo cha Kozi',
    undo: 'Rudisha',
    apply_changes: 'Tumia Mabadiliko',
    characters: 'wahusika',
    apply_all: 'Tumia Zote',
    apply_to_all: 'Tumia kwa Zote',
    use_this_content: 'Tumia Yaliyomo Haya',
    original: 'Asili',
    edited: 'Imehaririwa',
    edited_content_preview: 'Angalia Yaliyomo Imehaririwa',
    apply_edits_to_all_topices: 'Tumia mabadiliko kwa mada zote?',
    current_editing_instructions_across_the_whole_course:
      'Hii itatumia maagizo yako ya sasa kwenye kozi yote. Unaweza kuangalia mapema yote kabla ya kuhifadhi.',
    edit_content_instructions: 'Maagizo ya kuhariri Yaliyomo',
    generate_content_for_this_topic_instruction:
      'Tengeneza maudhui kwa mada hii kwa kutumia maagizo yako',
    descrip_edit_content:
      'Eleza jinsi ya kuhariri yaliyomo (mfano, fupisha, rahisisha, badilisha maneno)',
    try_short_clear_direcctives:
      'Jaribu maagizo mafupi na wazi. Mfano: “punguza maneno 100, hifadhi pointi muhimu”, “rahisisha lugha”, “fanya kifupi na toa ziada”.',
    we_preserve_the_core_meaning:
      'Tunahifadhi maana kuu wakati wa kutumia maagizo yako.',
    feedback_optional: 'Maoni (Hiari)',
    write_your_feedback_here: 'Andika maoni yako hapa',
    from_web: 'Kutoka Wavuti',
    from_desktop: 'Kutoka Kompyuta',
    pleae_wait_processing: 'Tafadhali subiri wakati inachakatwa...',
    create_simulation_from_screen_capture:
      'Tengeneza Mlinganyo Kutoka Kwenye Skrini',
    sharelook_not_found: 'ShareLook Haikupatikana',
    sharelook_screen_capture_application_not_be_opened:
      'Programu ya ShareLook Screen Capture haiwezi kufunguliwa. Huenda haijawekwa kwenye kompyuta yako.',
    download_sharelook: 'Pakua ShareLook',
    launch_sharelook_application: 'Anzisha Programu ya ShareLook',
    this_will_open_the_sharelook_application_for_screen_capture:
      'Hii itafungua programu ya ShareLook kwa ajili ya kurekodi skrini.',
    sharelook_dosenot_open:
      'Kama ShareLook haifungui, huenda haijawekwa kwenye kompyuta yako.',
    open_sharelook: 'Fungua ShareLook',
    download_app: 'Pakua Programu',
    background_image_setting: 'Mipangilio ya Picha ya Nyuma',
    current_image: 'Picha ya Sasa',
    change_image: 'Badilisha Picha',
    remove_image: 'Ondoa Picha',
    no_background_image_selected: 'Hakuna picha ya nyuma imechaguliwa',
    add_image: 'Ongeza Picha',
    this_will_open_for_screen_recording:
      'Hii itafungua programu ya ShareLook kwa kurekodi skrini.',
    ai_image_generation: 'Kizazi cha Picha cha AI',
    image_edit: 'Hariri Picha',
    text_to_image: 'Maneno Kuwa Picha',
    output_gallary: 'Galeria ya Matokeo',
    instant_generation: 'Tayari kwa kizazi cha haraka',
    prompt_and_unleash_the_power: 'Weka maagizo na fungua nguvu',
    use_this_image: 'Tumia Picha Hii',
    error_generating: 'Kosa wakati wa kutengeneza.',
    generation_tips: 'Vidokezo vya Kizazi',
    detailed_descriptions_for_more_accurate_results:
      'Tumia maelezo ya kina kwa matokeo sahihi zaidi',
    reference_image: 'Picha ya Kumbuka',
    select_pixel_image: 'Chagua Picha ya Pikseli',
    max_mb: 'Max 50MB',
    please_enter_text_to_appear_image:
      'Tafadhali weka maandishi yatakayojitokeza kwenye picha',
    enter_text_to_apear_in_the_image:
      'Andika maandishi yatakayojitokeza kwenye picha',
    generate_image: 'Tengeneza Picha',
    prompt_assistant: 'Msaidizi wa Maagizo',
    generate_image_using_suggested_prompt:
      'Tengeneza Picha Kutumia Maagizo Yaliyo Pendekezwa',
    talk_to_ai_about_the_image_generate:
      'Zungumza na AI kuhusu picha unayotaka kutengeneza',
    ask_for_prompt_suggestions: 'Omba mapendekezo ya maagizo...',
    enter_a_search_term_to_find_stock_images:
      'Ingiza neno la utafutaji kupata picha za hifadhi',
    choose_your_content_source: 'Chagua chanzo chako cha maudhui:',
    upload_new_document_from_your_device:
      'Pakia nyaraka mpya kutoka kifaa chako',
    automatic_library_selection: 'Chaguo la Kiotomatiki la Maktaba',
    system_automatically_selects_relevant_document:
      'Mfumo unachagua nyaraka zinazofaa kiotomatiki',
    manual_library_selection: 'Chaguo la Mkono la Maktaba',
    generate_content: 'Tengeneza Maudhui',
    add_to_current_page: 'Ongeza kwenye Kurasa ya Sasa',
    generate_bullet_points: 'Tengeneza Vidokezo Muhimu',
    generating: 'Inatengeneza',
    this_may_take_a_few_moments: 'Hii inaweza kuchukua muda mfupi',
    apply_to_page: 'Tumia kwenye Kurasa',
    scenario_escription: 'Maelezo ya Hali:',
    feedback: 'Maoni',
    form_mode: 'Hali ya Fomu',
    chat_mode: 'Hali ya Chat',
    this_will_generate_a_continuation_of_the_seleccted_story:
      'Hii itazalisha kuendelea kwa hadithi iliyochaguliwa kwa kutumia AI.',
    continue_this_story_question: 'Endelea na Hadithi Hii?',
    continue_this_story: 'Endelea na Hadithi Hii',
    what_will_happen: 'Nini kitatokea:',
    the_ai_will_analyze_the_existing_story_content:
      'AI itachambua maudhui ya hadithi iliyopo',
    generate_a_natural_continuation_that_follows_the_same_tone:
      'Zalisha kuendelea kwa asili ambacho kinafuata sauti na mtindo huo huo',
    create_new_content_that_build_upon_the_current_narrative:
      'Tengeneza maudhui mapya yanayojenga juu ya hadithi iliyopo',
    this_process_may_take_a_few_moments_to_complete:
      'Mchakato huu unaweza kuchukua muda kidogo kukamilika.',
    no_existing_stories_found_for_this_course:
      'Hakuna hadithi zilizopo zilizopatikana kwa kozi hii.',
    create_your_first_story: 'Tengeneza Hadithi Yako ya Kwanza',
    existing_stories: 'Hadithi Zilizopo',
    create_new_story: 'Tengeneza Hadithi Mpya',
    tone: 'Sauti',
    style: 'Mtindo',
    genre: 'Aina',
    loading_your_stories: 'Inapakia hadithi zako...',
    edit_story: 'Hariri Hadithi',
    story_preferences: 'Mapendeleo ya Hadithi',
    please_input_your: 'Tafadhali ingiza yako',
    add_character_names_and_press_enter:
      'Ongeza majina ya wahusika kisha bonyeza Enter',
    select_or_type_your: 'Chagua au andika yako',
    enter_your: 'Ingiza yako',
    position_of_the_story_in_the_lesson:
      'Nafasi ya hadithi katika somo. Hadithi itaongezwa kama kipande katika nafasi iliyobainishwa.',
    save_previous_content_on_the_pages:
      'Hifadhi maudhui ya awali kwenye kurasa',
    the_existing_content_in_the_selected_pages:
      'Maudhui yaliyopo kwenye kurasa zilizochaguliwa yataondolewa na hadithi iliyozalishwa.',
    real_world_scenario: 'Hali Halisi ya Dunia',
    add_optional_instructions:
      'Ongeza maelekezo ya hiari (sauti, urefu, hadhira, nk.)',
    ready_to_enerate_your_real_world_scenario:
      'Tayari kuunda Hali Halisi ya Dunia yako',
    click_generate_real_world_scenario_to_create_a_realistic_scenario:
      'Bofya "Zalisha Hali Halisi ya Dunia" kuunda hali halisi kulingana na maudhui ya somo lako.',
    the_ai_will_analyze_your_lesson_topic_and_content:
      'AI itachambua mada ya somo lako na maudhui yake',
    generate_a_practical_real_world_scenario:
      'Zalisha hali halisi ya dunia inayofaa',
    you_can_then_edit_and_customize_the_result:
      'Baada yake unaweza kuhariri na kubinafsisha matokeo',

    add_it_as_a_new_page_to_your_lesson:
      'Ongeza kama ukurasa mpya kwenye somo lako',
    regenerate_with_instructions: 'Zalisha Upya kwa Maelekezo',
    add_real_world_scenario: 'Ongeza Hali Halisi ya Dunia',
    generate_real_world_scenario: 'Zalisha Hali Halisi ya Dunia',
    simulation_has_been_stopped: 'Uigaji umesimama!',
    loading_simulation: 'Inapakia Uigaji...',
    you_have_exhausted_all_the_attempts: 'Umeishia majaribio yote',
    study_the_scenario_on_this_page_and_select_the_correct_answer:
      'Soma hali iliyopo kwenye ukurasa huu kisha chagua jibu sahihi kutoka kwa chaguzi zilizopo.',
    attempts_limit_reached:
      'Kikomo cha majaribio kimefikiwa. Unaweza kucheza tena lakini alama yako haitahifadhiwa.',
    play_again: 'Cheza Tena',
    import_music_from_computer: 'Ingiza muziki kutoka kwenye kompyuta.',
    more: 'zaidi',
    no_badge_yet: 'Hakuna alama bado',
    competition_filter: 'Kichujio cha Mashindano',
    global_leaderboard: 'Jedwali la Viongozi wa Ulimwenguni',
    placeholder_for_the_global_leaderboard:
      'Hii ni nafasi ya Jedwali la Viongozi wa Ulimwenguni.',
    badge_editor: 'Mhariri wa Alama',
    adjust_the_appearance_of_this_badge_icon:
      'Badilisha muonekano wa ikoni hii ya alama. Mabadiliko yanaweza kutumika kwa alama hii tu.',
    badge_style: 'Mtindo wa Alama',
    the_image_must_be_pixels: 'Picha lazima iwe 200x200 pikseli.',
    badge_name: 'Jina la Alama',
    badge_descrription: 'Maelezo ya Alama',
    enter_badge_criteria: 'Weka vigezo vya alama',
    discard: 'Futa',
    badge_enable: 'Alama Zimewezeshwa',
    award_users_with_badges_to_highlight_the_milestones:
      'Tunia watumiaji alama kuonyesha hatua muhimu katika safari yao ya kujifunza.',
    badge_types: 'Aina za Alama',
    enable_or_disable_specific_badge_types_for_your_users:
      'Wezesha au ulemese aina maalum za alama kwa watumiaji wako.',
    levels_enabled: 'Viwango Vimewezeshwa',
    level_rules: 'Sheria za Kiwango',
    points: 'Pointi',
    add_new_level: 'Ongeza Kiwango Kipya',
    add_level: 'Ongeza Kiwango',
    points_enabled: 'Pointi Zimewezeshwa',
    learning_activities_and_encourage_healthy_competition:
      'Tunia pointi kwa watumiaji kwa shughuli mbalimbali za kujifunza na kuhimiza ushindani mzuri.',
    award_points: 'Tunia Pointi',
    the_following_equates_the_value_of_one_item_completion:
      'Ifuatayo inalingana na thamani ya kukamilisha kipengele kimoja',
    general: 'Jumla',
    others: 'Wengine',
    certificate: 'Cheti',
    quiz_passed: 'Jaribio limepita',
    tip_approved: 'Ushauri Umeridhishwa',
    tip_liked: 'Ushauri Umependwa',
    rewards: 'Zawadi',
    offer_discounts_when_learners_achieve:
      'Toa punguzo wakati wanafunzi wanapofikia seti ya pointi, alama au viwango.',
    give_rewards: 'Toa Zawadi',
    discount_course_purchases_by: 'Punguza bei ya ununuzi wa kozi kwa',
    with_points_more_than: 'na pointi zaidi ya',
    with_badges_more_than: 'na alama zaidi ya',
    with_level_upwards_more_than: 'na kiwango cha juu zaidi ya',
    leaderboard: 'Jedwali la Viongozi',
    leaderboard_enabled: 'Jedwali la Viongozi Limewezeshwa',
    leaderboards_offer_users_an_overview_of_their_learning_progress:
      'Majedwali ya viongozi huwapa watumiaji muhtasari wa maendeleo yao ya kujifunza kwa pointi ikilinganishwa na wengine.',
    show_levels: 'Onyesha Viwango',
    show_points: 'Onyesha Pointi',
    show_badges: 'Onyesha Alama',
    show_courses: 'Onyesha Kozi',
    show_certificates: 'Onyesha Vyeti',
    leaderboard_settings: 'Mipangilio ya Jedwali la Viongozi',
    set_up_engaging_leaderboard_experiences_to_boost_learner_motivation:
      'Andaa uzoefu wa jedwali la viongozi unaovutia kuongeza motisha ya mwanafunzi.',
    award_users_with_points_for_different_learning_activities:
      'Tunia pointi kwa watumiaji kwa shughuli mbalimbali za kujifunza.',
    badge_set: 'Seti ya Alama',
    choose_the_type_of_badges_your_users:
      'Chagua aina ya alama ambazo watumiaji wako watapata wanapojifunza.',
    levels: 'Viwango',
    Levels_represent_the_stages:
      'Viwango vinaonyesha hatua katika safari ya kujifunza ya mtumiaji.',
    enabled: 'Imewezesha',
    disabled: 'Imelemazwa',
    quick_select: 'Chaguo la Haraka',
    yesterday: 'Jana',
    last_week: 'Wiki iliyopita',
    Last_month: 'Mwezi uliopita',
    last_quarter: 'Robo iliyopita',
    historical_leaderboard: 'Jedwali la Viongozi la Historia',
    track_your_performance_and_see_how_you_rank_among_your_peers:
      'Fuatilia utendaji wako na uone jinsi unavyojitokeza kati ya wenzako',
    time_period: 'Muda',
    page_of: 'Ukurasa 1 wa 1',
    edit_competition: 'Hariri Mashindano',
    create_competition: 'Tengeneza Mashindano',
    arrow_right: 'mshale-kulia',
    update_competition: 'Sasisha Mashindano',
    competition_title: 'Kichwa cha Mashindano',
    enter_competition_title: 'Ingiza kichwa cha mashindano',
    enter_competition_description: 'Ingiza maelezo ya mashindano',
    leaderboard_skill: 'Ujuzi',
    select_a_skill: 'Chagua ujuzi',
    no_skills_found: 'Hakuna ujuzi ulio patikana',
    competition_period: 'Muda wa Mashindano',
    add_badge_rule: 'Ongeza Kanuni ya Alama',
    create_badge: 'Tengeneza Alama',
    add_level_rule: 'Ongeza Kanuni ya Kiwango',
    selected_participants: 'Washiriki Waliochaguliwa',
    no_participants: 'Hakuna washiriki',
    start_end_date: 'Tarehe ya Kuanzia–Mwisho',
    created_date: 'Imeundwa na',
    new_competition: 'Mashindano Mapya',
    competitions_list: 'Orodha ya Mashindano',
    search_competitions: 'Tafuta mashindano...',
    are_you_sure_you_want_to_delete_the_competition:
      'Una uhakika unataka kufuta mashindano haya?',
    history: 'Historia',
    export: 'Hamisha',
    search_by_name: 'Tafuta kwa jina...',
    no_historical_data_available_for_the_selected_period:
      'Hakuna data ya kihistoria inayopatikana kwa kipindi kilichochaguliwa.',
    no_leaderboard_data_available:
      'Hakuna data ya jedwali la viongozi inayopatikana.',
    competitions: 'Mashindano',
    leaderboards: 'Majedwali ya Viongozi',
    welcome_back: 'Karibu tena',
    track_your_performance_and_see:
      'Fuatilia utendaji wako na uone nafasi yako',
    team_leaderboard: 'Jedwali la Viongozi la Timu',
    try_again: 'Jaribu Tena',
    no_competitions_for_search: 'Hakuna mashindano yanayopatikana kwa',
    no_competitions_available: 'Hakuna mashindano yanayopatikana',
    no_competitions_matching_search:
      'Hakuna mashindano yanayolingana na utafutaji wako. Jaribu kurekebisha maneno ya utafutaji au rudi baadaye.',
    no_competitions_general:
      'Kwa sasa hakuna mashindano yaliyowekwa. Rudi baadaye au wasiliana na msimamizi wako kuunda mashindano mapya.',
    media_management: 'Usimamizi wa Vyombo vya Habari',
    badgess_set: 'Seti ya Alama',
    choose_the_default_visual_style_for_badge:
      'Chagua mtindo wa chaguo-msingi wa ikoni za alama zinazotumika kwenye jukwaa.',
    enable_badges: 'Wezesha Alama',
    add_badge: 'Ongeza Alama',
    min: 'Chini',
    max: 'Juu',
    your_rank: 'Cheo chako',
    your_points: 'Pointi zako',
    your_level: 'Kiwango chako',
    rank: 'Cheo #',
    level: 'Kiwango',
    progress: 'Maendeleo',
    new_folder: 'Folda Mpya',
    file_upload: 'Pakia Faili',
    writer: 'Mwandishi',
    text_documents: 'Hati za Maandishi',
    spreadsheets: 'Vilele vya Hesabu',
    impress: 'Onyesha',
    presentations: 'Maonyesho',
    capture_desktop_screen: 'Chukua Skrini ya Kompyuta',
    capture_desktop_screens: 'Chukua Skrini za Kompyuta',
    your_documents: 'Hati Zako',
    manage_your_videos_images_audio_files:
      'Simamia video zako, picha, faili za sauti, na mali nyingine zinazotumika katika uundaji wa maudhui.',
    your_organization_documents: 'Hati za Shirika Lako',
    keep_your_organization_creative_assets_organized:
      'Weka mali za ubunifu za shirika lako zikiwa zimepangwa na kufikika—rahisisha kazi ya timu na utengenezaji wa maudhui.',
    your_public_documents: 'Hati Zako za Umma',
    curated_collection_of_media_assets_available:
      'Mk Collections ulioratibiwa wa mali za vyombo vya habari zinazopatikana kwa kila mtu—gundua, tumia tena, na unda.',
    your_download_center_documents: 'Hati za Kituo chako cha Upakuaji',
    repository_of_approved_media_assets_for_download:
      'Hifadhi ya mali za vyombo vya habari zilizokubaliwa kwa kupakuliwa na kutumika kwenye miradi yako.',
    search_files_and_folders: 'Tafuta faili na folda..',
    home: 'Nyumbani',
    folders: 'Folda',
    folder_name: 'Jina la Folda',
    owner: 'Mmiliki',
    last_updated: 'Imesasishwa Mwisho',
    action: 'Kitendo',
    no_folders_found: 'Hakuna folda zilizopatikana',
    files: 'Faili',
    enabling_ai: 'Kuwezesha AI...',
    rename: 'Badilisha Jina',
    copy: 'Nakili',
    move: 'Hamisha',
    verson_history: 'Historia ya Toleo',
    manage_permission: 'Simamia Ruhusa',
    generate_audit_report: 'Zalisha Ripoti ya Ukaguzi',
    last_edited: 'Imehaririwa Mwisho',
    no_files_found: 'Hakuna faili zilizopatikana',
    are_you_sure_you_want_to_make_this_item_public:
      'Una uhakika unataka kufanya kipengele hiki kuwa cha umma? Kita nakiliwa kwenye maktaba yako ya umma.',
    move_to_organization: 'Hamisha kwa Shirika',
    are_you_sure_you_want_to_copy_this_item_to_your_organization_library:
      'Una uhakika unataka kunakili kipengele hiki kwenye maktaba ya shirika lako?',
    are_you_sure_you_want_to_make_this_item_private:
      'Una uhakika unataka kufanya kipengele hiki kuwa cha kibinafsi? Kita nakiliwa kwenye maktaba yako binafsi.',
    date_modified: 'Tarehe Iliyobadilishwa',
    workflow_management: 'Usimamizi wa Mtiririko wa Kazi',
    configure_editors_approvers_and_viewers_for_this_document:
      'Sanidi wahariri, wathibitishaji na watazamaji kwa hati hii.',
    error_Loading_editor: 'Hitilafu Wakati wa Kupakia Mhariri',
    debug_info: 'Taarifa za Kurekebisha',
    loading_editor: 'Inapakia Mhariri...',
    submitted_for_review: 'Imetumwa kwa Mapitio',
    editors: 'Wahariri',
    no_editors_added_yet:
      'Hakuna wahariri waliyo ongezwa bado. Bonyeza "Ongeza Mhariri" kuongeza mmoja.',
    add_editor: 'Ongeza Mhariri',
    approvers: 'Wathibitishaji',
    no_approvers_added_yet:
      'Hakuna wathibitishaji waliyo ongezwa bado. Bonyeza "Ongeza Mthibitishaji" kuongeza mmoja.',
    add_approvers: 'Ongeza Wathibitishaji',
    viewer: 'Mtaazamaji',
    no_viewers_added_yet:
      'Hakuna watazamaji waliyo ongezwa bado. Bonyeza "Ongeza Mtaazamaji" kuongeza mmoja.',
    add_viewer: 'Ongeza Mtaazamaji',
    are_you_sure_you_want_to_delete_the_selected_items:
      'Una uhakika unataka kufuta vitu vilivyochaguliwa?'
  },
  v3: {
    reportShareSphere: 'Eneo la Kushiriki',
    overview: 'Muhtasari wa Jamii',
    triviaReport: 'Jamii ya ShareSphere',
    overviewGraph: 'Grafu ya Muhtasari wa Jamii',
    category: 'Jamii',
    phCategory: 'Chagua jamii',
    podcast: 'Podikasti, muziki na hadithi',
    pastPodcast: 'Podikasti Zilizopita',
    upcomingPodcast: 'Podikasti Zijazo',
    podcastLanguageTitle: 'Lugha ya Podikasti, Muziki na Hadithi',
    podcastLanguageCheckbox: 'Tumia AI kwa lugha ya podikasti yangu',
    howRate: 'Unakadiriaje podikasti hii?',
    podcastSubmit: 'Tuma',
    podcastGuest: 'Mgeni:',
    podcastReview: 'Maoni',
    podcastEpishode: 'Kipindi',
    podcastEnd: 'Podikasti Imeisha',
    date_podcast: 'Tarehe ya Podikasti',
    skill_not_found: 'Samahani! Njia ya ujuzi haikupatikana.',
    coaching: 'Mafunzo',
    webinar: 'Mtandao wa Kuwezesha',
    public_conference: 'Mkutano wa Umma',
    skill_journey_subtitle:
      'Sanidi safari yako ya ujuzi na chagua ni nani anaweza kuiona na kuingiliana nayo.',
    enable_white_label: 'Wezesha Alama Nyeupe',
    create_new_event_org: 'Unda tukio jipya kwa shirika lako',
    create_new_event_marketplace: 'Unda tukio jipya kwa soko',
    create_new_event_both: 'Unda tukio jipya kwa shirika lako na soko',
    event_outline: 'Ingiza muhtasari wa tukio',
    event_obj: 'Ingiza malengo ya tukio',
    event_description: 'Ingiza maelezo ya tukio',
    create_new_metamaze_org: 'Unda MetaMaze mpya kwa shirika lako',
    create_new_metamaze_marketplace: 'Unda MetaMaze mpya kwa soko',
    create_new_metamaze_both: 'Unda MetaMaze mpya kwa shirika lako na soko',
    add_key_words: 'Ongeza maneno muhimu',
    press_enter_make_keyword: 'Bonyeza Enter kuunda neno muhimu',
    disable_skip_quiz: 'Zima ruka jaribio',
    warning_complete_quiz: 'Tafadhali kamilisha jaribio ili kuendelea.',
    signup_email_verification:
      'Tumetuma kiungo cha uthibitisho kwa barua pepe yako. Tafadhali bonyeza ili kuthibitisha usajili wako.',
    verifying_registration: 'Inathibitisha usajili...',
    reset_password_linK:
      'Tumetuma kiungo cha kuweka upya nenosiri kwa barua pepe yako. Bonyeza kiungo ili kuweka nenosiri jipya.',
    reset_email_error:
      'Mtumiaji mwenye barua pepe hiyo hakupatikana, jaribu jina la mtumiaji wako!',
    first_name: 'Jina la Kwanza',
    last_name: 'Jina la Mwisho',
    error_firstName: 'Tafadhali ingiza jina lako la kwanza',
    error_sharebot_organization: 'Tafadhali ingiza shirika',
    error_lastName: 'Tafadhali ingiza jina lako la mwisho',
    private_conference: 'Mkutano wa Kibinafsi',
    public_conference: 'Mkutano wa Umma',
    discussion_room: 'Chumba cha Majadiliano',
    training_no_courses: 'Kwa sasa hujajiandikisha katika kozi yoyote.',
    training_no_events: 'Kwa sasa hushiriki katika tukio lolote.',
    allow_sharing_trainer_info: 'Ruhusu soko kushiriki barua pepe ya mkufunzi',
    error_username_space: 'Jina la mtumiaji haliwezi kuwa na nafasi.',
    error_sharebot_organization_space:
      'Jina la shirika haliwezi kuwa na nafasi.',
    edit_permission: 'Ruhusa ya kuhariri',
    valid_price: 'Bei lazima iwe kubwa kuliko 0',
    course_price_message: `*Kozi zinapatikana tu kwa watumiaji waliokinunua kupitia shirika na haziwezi kuuzwa tena sokoni`,
    valid_edit_price: 'Bei ya kuhariri lazima iwe chini ya bei ya ununuzi.',
    my_calendar: 'Kalenda Yangu',
    error_valid_firstName: 'Tafadhali ingiza jina halali.',
    error_valid_organization: 'Tafadhali ingiza jina sahihi la shirika.',
    error_valid_lastName: 'Tafadhali ingiza jina halali la mwisho.',
    error_name_spaces: 'Jina halipaswi kuwa na nafasi',
    items: 'Vitu',
    publish_to_channel: 'Chapisha kwenye mkusanyiko wangu wa chaneli',
    create_a_channel: 'Unda chaneli yangu',
    create_a_trivia: 'Unda jaribio la maarifa',
    create_a_new_channel: 'Unda chaneli mpya',
    add_videos: 'Ongeza video',
    save_and_continue: 'Hifadhi na Endelea',
    channel: 'Chaneli',
    channels: 'Chaneli',
    view_channel: 'Tazama chaneli',
    edit_channel: 'Hariri chaneli',
    delete_channel: 'Futa chaneli',
    my_video_channels: 'Chaneli Zangu za Video',
    training_no_channel: 'Kwa sasa hushiriki katika chaneli yoyote.',
    monthly_price_required: 'Bei ya kila mwezi inahitajika',
    yearly_price_required: 'Bei ya kila mwaka inahitajika',
    one_time_price_required: 'Bei ya mara moja inahitajika',
    marketplace_quantity: 'Dola',
    report_webinar: 'Mtandao wa Kuwezesha',
    report_coaching: 'Mafunzo',
    report_channel: 'Chaneli',
    report_public_conference: 'Mkutano wa Umma',
    report_maze: 'Maze',
    channel: 'Chaneli',
    edit_price: 'Hariri Bei ($)',
    quantity: 'Kiasi',
    payment_type: 'Aina ya Malipo',
    total_amount: 'Jumla ($)',
    net_amount: 'Kiasi Halisi ($)',
    edit_option: 'Hariri Chaguo',
    marketplace_price: 'Bei ($)',
    market_name: 'Jina',
    duration_min: 'Muda (dakika)',
    users_total: 'Watumiaji (jumla)',
    sales_total: 'Mauzo Jumla (USD)',
    search_coaching: 'Tafuta mafunzo',
    search_channel: 'Tafuta chaneli',
    search_webinar: 'Tafuta mtandao',
    search_maze: 'Tafuta maze',
    search_public_conference: 'Tafuta mkutano wa umma',
    buyer_type: 'Aina ya Mnunuzi',
    quanity: 'Kiasi',
    channel_unit_amount: 'Kiasi Halisi ($)',
    channel_updated_at: 'Imesasishwa',
    month_price: 'Bei (kwa mwezi)',
    year_price: 'Bei (kwa mwaka)',
    one_time_price: 'Bei (mara moja)',
    sharebot_organization: 'Ongeza jina jipya la shirika',
    share_sphere: 'Eneo la Kushiriki',
    ai_course_title: 'Kichwa cha Kozi',
    ai_input_course_title: 'Tafadhali ingiza kichwa cha kozi!',
    learning_objective_label: 'Lengo la Kujifunza',
    learning_objective_message: 'Tafadhali ingiza lengo la kujifunza!',
    standard_question: 'Je, kuna kiwango ambacho mwanafunzi anapaswa kufuata?',
    standard_details_label: 'Maelezo ya Kiwango',
    standard_details_message: 'Tafadhali ingiza maelezo ya kiwango!',
    estimated_duration_label: 'Muda Unaokadiriwa wa Kozi (kwa dakika)',
    estimated_duration_message: 'Tafadhali ingiza muda unaokadiriwa!',
    min_duration_message: 'Muda wa chini kabisa ni dakika 5.',
    ai_mins: 'Dakika 25',
    industry_specific_question: 'Je, inahusiana na sekta maalum?',
    industry_label: 'Taja Sekta',
    industry_message: 'Tafadhali ingiza sekta!',
    ai_course_creation: 'Uundaji wa Kozi kwa Msaada wa AI',
    course_generated: 'Kozi Iliyotengenezwa na Sharelook',
    ai: 'AI',
    ai_you: 'Wewe',
    ai_prompt_ready:
      'Ombi lako liko tayari. Sasa unaweza kutengeneza jedwali la maudhui.',
    ai_unable_respond:
      'Samahani! AI haiwezi kujibu ombi lako kwa sasa. Tafadhali jaribu tena.',
    ai_hide_toc: 'Ficha Jedwali la Maudhui',
    ai_preview_toc: 'Onyesho la Awali la Jedwali la Maudhui',
    ai_generate_toc_now: 'Tengeneza Jedwali la Maudhui Sasa',
    ai_creation_course_title: 'Kichwa cha Kozi:',
    ai_creation_industry_specific: 'Je, Inahusiana na Sekta Maalum:',
    ai_creation_industry: 'Sekta:',
    ai_creation_standard_needed:
      'Je, Kuna Kiwango cha Kufuatwa na Mwanafunzi?:',
    ai_creation_standard_details: 'Maelezo ya Kiwango:',
    ai_creation_estimated_duration: 'Muda Unaokadiriwa wa Kozi (kwa Dakika):',
    minutes: 'dakika',
    ai_creation_learning_objective: 'Lengo la Kujifunza:',
    setup_again: 'Sanidi Tena',
    ai_creation_confirm_title: 'Una uhakika unataka kusanidi fomu tena?',
    ai_creation_confirm_content:
      'Mazungumzo na maudhui yote uliyotengeneza yatasetiwa upya.',
    ai_toc: 'Jedwali la Maudhui',
    ai_note_topic:
      'Kumbuka: Unaweza kuburuta na kudondosha kupanga upya mada ndani ya somo.',
    ai_add_topic: '+ Ongeza Mada',
    add_topic: 'Ongeza Mada',
    add_lesson: 'Ongeza Somo',
    add_new_lesson: 'Ongeza Somo Jipya',
    ai_add_lesson: '+ Ongeza Somo',
    attention: 'Tahadhari',
    before_varifying: 'Kabla ya Kuthibitisha',
    ai_save_later: 'Hifadhi kwa Baadaye',
    ai_download_word_doc: 'Pakua kama Hati ya Word',
    ai_download_course_word_doc: 'Pakua Kozi kama Hati ya Word',
    ai_create_course_button: 'Tengeneza Kozi',
    ai_generate_course_content: 'Tengeneza Maudhui ya Kozi',
    ai_out_of: 'ya',
    ai_subtopic_failed_content:
      'baadhi ya mada ndogo hazikuweza kuunda maudhui. Bonyeza “Tengeneza Maudhui ya Kozi” tena kutengeneza maudhui kwa zile tu zilizoshindwa.',
    ai_edit_topic: 'Hariri Mada',
    ai_edit_lesson_title: 'Hariri Kichwa cha Somo',
    ai_save_topic: 'Hifadhi Mada',
    ai_save: 'Hifadhi',
    ai_save_lesson_title: 'Hifadhi Kichwa cha Somo',
    ai_add_new_topic: 'Ongeza Mada Mpya',
    ai_download_ref: 'Pakua na Marejeo',
    ai_download_ref_content:
      'Kozi itapakuliwa kama hati ya Word yenye marejeo.',
    ai_download_without_ref: 'Pakua bila Marejeo',
    ai_download_two_word: 'Hati mbili za Word zitapakuliwa:',
    ai_download_two_word_content_one: '- moja yenye maudhui kuu bila marejeo,',
    ai_download_two_word_content_two:
      'na nyingine ikiwa na orodha ya marejeo pekee bila maudhui zaidi.',
    ai_manage_content: 'Dhibiti Maudhui',
    ai_add_content_from_internet: '+Ongeza Maudhui kutoka Mtandaoni',
    ai_confirm_start: 'Thibitisha Kuanza',
    ai_Verify: 'Thibitisha',
    ai_undo_warning:
      'Mchakato huu unaweza kuchukua muda. Usifunge dirisha hili hadi utakamilika kwani hautoweza kurudi nyuma.',
    ai_verified_content:
      'Umehakiki maudhui. Tafadhali fahamu kuwa baada ya kuthibitisha, hutoweza kurudi kwenye mazungumzo ya AI na maudhui haya.',
    ai_want_proceed: 'Una uhakika unataka kuendelea?',
    upload_simulation: 'Pakia Mlinganisho',
    name_simulation: 'Taja Mlinganisho',
    selected_simulation_files: 'Faili za Mlinganisho Zilizochaguliwa',
    score_between_one_hundred: 'Alama yako lazima iwe kati ya 1 na 100.',
    are_sure_simulation: 'Una uhakika unataka kufuta faili hii ya mlinganisho?',
    required_simulation: 'Alama inahitajika',
    required_section_file: 'Faili ya sehemu inahitajika',
    simulation: 'Mlinganisho',
    simulation_quiz_games: 'Jaribio lazima liongezwe kwenye michezo',
    simulation_alert_des:
      'Unaweza kuongeza michezo tu ikiwa maswali yote ni ya aina ya jibu moja au majibu mengi.',
    alert_info: 'taarifa',
    ai_number_quiz: 'Idadi ya Majaribio',
    ai_point: 'Alama',
    ai_points: 'Alama',
    val_required: 'Inahitajika',
    games: 'Michezo',
    add_simulation: 'Ongeza Mlinganisho',
    text_tiewer: 'Kionesha Maandishi',
    back_to_account: 'Rudi kwa Akaunti',
    delete_account: 'Futa Akaunti',
    delete_account_title: 'Futa Akaunti?',
    delete_account_subtitle: 'Unaweza kufuta akaunti yako hapa.',
    delete_account_cannot_undo:
      'Unakaribia kufuta akaunti yako. Hatua hii haiwezi kubatilishwa.',
    account_org_profile:
      'Pia utapoteza kozi zote ulizotengeneza, wasifu wa shirika lako, na mipangilio yote.',
    deleting_account_database:
      'Kufuta akaunti yako kutafuta data zako zote kutoka kwenye hifadhidata yetu.',
    account_confirm_delete: 'Una uhakika unataka kufuta akaunti yako?',
    action_cannot_be_undone: 'Hatua hii haiwezi kubatilishwa.',
    account_delete_message_success: 'Akaunti yako imefutwa kwa mafanikio.',
    message_edit: 'Hariri',
    message_delete: 'Futa',
    message_reply: 'Jibu',
    attached_file: 'Faili Iliyowekwa',
    attach_file: 'Weka Faili',
    attach_des: 'MB 25, ukubwa wa juu wa faili',
    view: 'Tazama',
    go_to_marketplace: 'Nenda kwenye Soko',
    learning_center: 'Kituo cha Kujifunza',
    knowledge_center: 'Kituo cha Maarifa',
    sharebot: 'ShareBot',
    sharebot_help_message: 'Naweza kukusaidia vipi leo?',
    my_organization: 'Shirika Langu',
    world_knowledge: 'Maarifa ya Dunia',
    welcome_to_sharelook: 'Karibu Sharelook!',
    sharelook_you_want_go: 'Unataka kwenda wapi leo?',
    shareLook_learning_management_system:
      'Fikia mfumo wa usimamizi wa kujifunza wa ShareLook kuunda au kufikia rasilimali za kujifunza kama matukio ya moja kwa moja na kozi ndani ya shirika lako katika ShareLook.',
    shareLook_powerful_ai_system:
      'Fikia mfumo wenye nguvu unaotumia AI wa ShareLook, ambapo unaweza kupakia hati za PDF na kupata maarifa papo hapo. Pata majibu ya haraka kutoka kwa rasilimali za shirika lako au kutoka kwa mfumo wetu wa maarifa ya dunia.',
    edit_now: 'Hariri Sasa',
    sharelook_log_out:
      'Umetoka kwenye akaunti ya Sharelook. Tafadhali ingia tena!',
    sorry_error: 'Samahani! Hitilafu imetokea.',
    login: 'Ingia',
    refresh_page: 'Onyesha Upya Ukurasa',
    just_a_moment: 'Subiri Kidogo',
    enter_lname_fname:
      'Tafadhali ingiza jina lako la kwanza na la mwisho ili kuendelea.',
    procced_to_sharelook: 'Endelea kwa Sharelook',
    option_one: 'Chaguo la 1',
    option_two: 'Chaguo la 2',
    selected_image: 'Picha Iliyopchaguliwa:',
    add_text: 'Ongeza Maandishi',
    linkdin_is_required: 'LinkedIn inahitajika.',
    bio_is_required: 'Wasifu unahitajika.',
    save_user_information: 'Hifadhi Taarifa za Mtumiaji',
    select_all: 'Chagua Zote',
    enable_ai: 'Wezesha AI',
    load_more: 'Pakia Zaidi',
    channel_id: 'Kitambulisho cha Kituo',
    send: 'Tuma',
    v4: 'Taarifa',
    subscription: 'Usajili',
    reset_user_flag: 'WASHA ISHARA YA MTUMIAJI UPYA',
    delete_my_accont: 'Futa Akaunti Yangu',
    sharebot_sub_error: 'Hitilafu ya kupata usajili. Tafadhali jaribu tena!',
    sharebot_no_sub: 'Huna usajili wowote ulio hai kwa sasa.',
    sharebot_dont_sub: 'Huna usajili wowote wa awali.',
    sharebot_prev_sub: 'Usajili wa Awali',
    sharebot_sub: 'Usajili wa ShareBot',
    sharebot_un_sub: 'Batilisha Usajili wa ShareBot',
    sharebot_no_available: 'Hakuna Maelezo Yanayopatikana',
    sharebot_start_date: 'Tarehe ya Kuanza:',
    sharebot_end_date: 'Tarehe ya Mwisho:',
    sharebot_sure: 'Una uhakika?',
    sharebot_do_you_want: 'Je, unataka',
    unsubscribe: 'kujiondoa',
    unsubscribe_what: 'kujiondoa?',
    subscribe: 'jisajili',
    subscribe_what: 'jisajili?',
    subscribe_now: 'Jisajili Sasa',
    confirm: 'Thibitisha',
    sharebot_intel_knowledge_center: 'Kituo cha Maarifa ya Akili cha ShareBot',
    sharebot_welcome_paragraph:
      'Karibu kwenye Kituo cha Maarifa ya ShareBot, roboti ya kisasa ya AI iliyoundwa kubadilisha jinsi wataalamu wanavyopata taarifa na kushirikiana.',
    expired: 'Imeisha Muda',
    active: 'Hai',
    Inactive: 'Imesitishwa',
    yearly_subscription: 'Usajili wa Mwaka',
    monthly_subscription: 'Usajili wa Kila Mwezi',
    no_sharebot_org: 'Huna shirika la ShareBot',
    sharebot_start_free_trial: 'Anza Jaribio la Bure',
    sub_month: 'Usajili wa Kila Mwezi',
    sub_year: 'Usajili wa Kila Mwaka',
    question_per_month: 'Hifadhi ya Data (1TB) na Maswali 1000 kwa Mwezi',
    sharebot_para:
      'Kwa kuendelea, unathibitisha kufutwa kwa shirika mara moja. Hatua hii itasababisha kupotea kwa maarifa yote muhimu kutoka ShareBot, na haiwezi kutenduliwa.',
    cancelled_date: 'Tarehe ya Kufutwa:',
    live_straming_para:
      'Ikiwa ungependa kubadilisha kikomo chako cha kila mwezi cha matangazo ya moja kwa moja, tafadhali wasiliana na',
    sharelook_agree: 'Ninakubali',
    terms_condition: 'vigezo na masharti',
    and: 'na',
    privacy_policy: 'sera ya faragha',
    save_for_later: 'Hifadhi kwa Baadaye',
    ai: 'AI',
    no_video_yet: 'Hakuna Video Iliyoteuliwa Bado!',
    are_you_sure_delete_video: 'Una uhakika unataka kufuta video hii?',
    video_des: 'Maelezo',
    video_now: 'Sasa',
    video_playing: 'Inachezwa:',
    video_no: 'Video Na.',
    ai_generated_course: 'Kozi Iliyotengenezwa na AI',
    create_course_on_our_own: 'Tengeneza Kozi Mwenyewe',
    ai_Assisted_ourse_reation: 'Uundaji wa Kozi kwa Msaada wa AI',
    pending: 'Inasubiri',
    published: 'Imechapishwa',
    intro_course: 'kwenye kozi yako?',
    clone_course: 'Ungependa kunakili',
    browser_audio_not_support: 'Kivinjari chako hakitumii tagi ya sauti.',
    audio_popup_content:
      'Hapa unaweza kutumia mitindo mbalimbali ya sauti kwa maandishi unayoandika. Bla bla bla. Lorem Ipsum ni maandishi ya mfano katika sekta ya uchapishaji na uandishi.',
    close: 'Funga',
    podcast_rec: 'REKODI',
    create_podcast: 'Tengeneza Podcast',
    add_admin: 'ONGEZA MSIMAMIZI',
    delete_all: 'Futa Vyote',
    ai_podcast_audio: 'Sauti ya Podcast ya AI',
    language: 'Lugha',
    podcast_download_content:
      '*Pakua faili ya sauti ya AI ili kuihariri kama faili yako binafsi.',
    upload_audio: 'Pakia Sauti',
    browser_do_not_support_audio:
      'Kivinjari chako hakitumii kipengele cha sauti.',
    upload_cover: 'Pakia Picha ya Jalada',
    upload_ai_creator: 'Mtayarishaji wa AI',
    required_cover_image: 'Picha ya jalada inahitajika!',
    room_required_name: 'Jina la podcast linahitajika!',
    add_guest_list: 'Tafadhali ongeza orodha ya wageni!',
    podcast_add_participants: 'ONGEZA WASHIRIKI',
    topic_required: 'Angalau mada moja inahitajika',
    podcast_description: 'MAELEZO',
    podcast_date: 'TAREHE',
    date: 'Tarehe',
    podcast_time: 'wakati',
    podcast_to: 'hadi',
    podcast_all_day: 'Siku nzima',
    podcast_start_date_time: 'Tarehe na Muda wa Kuanza Vinahitajika!',
    podcast_id: 'ID',
    selected_user: 'Alika Watumiaji Waliochaguliwa',
    see_more: 'Tazama Zaidi',
    see_less: 'Tazama Chache',
    no_review_yet: 'Bado hakuna tathmini, kuwa wa kwanza kutoa tathmini.',
    request_to_speak: 'Kubali ombi la mtumiaji kuzungumza?',
    kick_user: 'Unataka kumtoa mtumiaji huyu?',
    accept_request: 'Kubali Ombi',
    kick: 'TOA',
    started: 'IMEANZA',
    end: 'MWISHO',
    join_now: 'Jiunge Sasa',
    podcast_end: 'Podcast imeisha',
    connecting: 'inaunganisha...',
    knowledge_center_know_today: 'Ungependa kujua nini leo?',
    knowledge_center_question: 'Tafadhali weka swali kwanza',
    knowledge_center_error: 'Samahani! Tumepata hitilafu.',
    knowledge_center_tooltrip:
      'Pata majibu ya haraka kutoka kwa rasilimali za kujifunzia katika hifadhidata ya shirika lako kwenye ShareLook, zikiwa na marejeo sahihi na uwezo wa kuonyesha na kupakua hati za PDF.',
    my_organization: 'Shirika Langu',
    world_knowledge: 'Maarifa ya Dunia',
    open_file: 'Fungua Faili',
    reference: 'Rejea',
    are_you_cancel: 'Una uhakika unataka kughairi?',
    are_you_remove_media: 'Una uhakika unataka kuondoa faili hii ya media?',
    terms_agree: 'Ninakubali',
    ready: 'Tayari',
    send_email: 'TUMA BARUA PEPE',
    active_users: 'Watumiaji Hai',
    sign_up_user: 'Watumiaji Waliosajiliwa',
    non_sign_up_user: 'Watumiaji Wasiokuwa Wamesajiliwa',
    organisation: 'Shirika',
    usage_report: 'Ripoti ya Matumizi',
    check_email: 'angalia barua pepe yako',
    delete_schedule: 'Futa Ratiba',
    are_you_sure_delete_schedule: 'Una uhakika unataka kufuta ratiba hii?',
    add_task: 'Tafadhali ingiza kazi!',
    coaching_available: 'Weka Alama ya Upatikanaji wa Mafunzo',
    message_booking_coaching:
      'Wakati huu umehifadhiwa na mtumiaji kwa mafunzo.',
    task_day: 'Siku ya Kazi',
    created_task_day: 'Umeunda kazi kwa siku hii.',
    event_day: 'Siku ya Tukio',
    has_booked_coaching: 'Mafunzo yamehifadhiwa kwa siku hii.',
    active_day: 'Siku Hai',
    selectable_time_slots:
      'Vipindi vya muda vinavyoweza kuchaguliwa upande wa kulia viko hai kwa siku hii.',
    compare_last_month: 'Ikilinganishwa na Mwezi Uliopita',
    uploading_file: 'Inapakia faili yako',
    attach_file_course: 'imeambatanishwa na kozi hii.',
    fetch_request: 'Inachakata ombi lako',
    finilize_upload: 'Inakamilisha upakiaji',
    scorm_scanned: 'Tafadhali subiri... Faili yako ya SCORM inachanganuliwa.',
    scan_status: 'Hali ya Uchunguzi:',
    scan_completed: 'Uchunguzi Umekamilika. Faili yako ni',
    scan_progress: 'Uchunguzi unaendelea...',
    check_scorm: 'Inakagua umbizo la faili ya SCORM... Tafadhali subiri...',
    file_check_success: 'Ukaguzi wa faili umefaulu',
    file_check_progress: 'Ukaguzi wa faili unaendelea...',
    scorm_not_upload:
      'Faili uliyopakia si ya kiwango cha SCORM 1.2, Tafadhali pakia faili tena.',
    select_question: 'Chaguzi za Majibu (chagua jibu sahihi moja)',
    select_answer: 'Tafadhali chagua jibu!',
    check_option_one: 'Tafadhali ingiza chaguo la kwanza!',
    check_option_two: 'Tafadhali ingiza chaguo la pili!',
    check_option_three: 'Tafadhali ingiza chaguo la tatu!',
    check_option_four: 'Tafadhali ingiza chaguo la nne!',
    question_image: 'Picha ya Swali',
    select_question_image: 'Tafadhali chagua picha ya swali!',
    ans_image: 'Picha ya Jibu',
    upload_image_question: 'Pakia Picha ya Jibu',
    select_image_answer: 'Tafadhali chagua picha ya jibu!',
    save_question: 'Hifadhi Swali',
    do_you_leave: 'Una uhakika unataka kuondoka?',
    loose_all_progress: 'Utapoteza maendeleo yako yote.',
    welcome: 'Karibu',
    team_knowledge_quest: 'Safari ya Maarifa ya Timu',
    your_score: 'Alama Yako',
    start_playing: 'Anza Kucheza',
    share_sphere_complete: 'ShareSphere Imefanikiwa',
    final_score: 'Alama ya Mwisho',
    play_next: 'Cheza Ifuatayo',
    you_donot_access_event: 'Huna ruhusa ya tukio hili.',
    ai_content_generated: 'Maudhui yameundwa kwa mada hii.',
    ai_popup_confirm_content: 'Thibitisha Uundaji wa Maudhui',
    limit_transcribe_text:
      'Dakika Zilizobaki za Kunakili: <0>{{ transcribe_limit }}</0> dakika <1/><2/> <3>. Ili kubadilisha kikomo chako cha kunakili, tafadhali wasiliana na </3> <4>admin@sharelook.com</4>.',
    you_donot_access_event: 'Huna ruhusa ya kufikia tukio hili.',
    ai_course_title_training: 'Kozi za mafunzo ya uongozi',
    ai_course_object: 'Kuongoza katika enzi ya kidijitali',
    create_ai_video: 'Tengeneza Video ya AI',
    generate: 'TENENEZA',
    video_generate_process:
      'Mchakato wa kutengeneza video unaweza kuchukua muda. Utapokea barua pepe baada ya kukamilika.',
    stripe_account_connect:
      'Akaunti yako ya Stripe haijawashwa. Tafadhali iunganishe au iwashe ili kuendelea.',
    ai_creator: 'Mtayarishaji wa AI',
    check_video_status: 'Inakagua hali ya utengenezaji wa video...',
    video_on_queue: 'Video iko kwenye foleni ya kutengenezwa.',
    video_fail_generation:
      'Samahani, utengenezaji wa video umeshindwa. Tafadhali jaribu nyingine.',
    video_currently_generated: 'Video hii inatengenezwa kwa sasa.',
    checking_status: 'Inakagua hali',
    check_status: 'Kagua Hali',
    browser_does_not_support_audio:
      'Kivinjari chako hakihusiani na tagi ya sauti',
    existing_edit_scenario:
      'Unataka kuhariri mazingira yaliyopo au kuunda mpya? Ukichagua mpya, mazingira ya zamani yatapotea.',
    generate_scenario: 'Tengeneza Mazingira',
    layout: 'Mpangilio',
    confirm_change: 'Thibitisha Mabadiliko',
    generated_ai_creation_message:
      'Tafadhali kumbuka kuwa vipengele vya maandishi vilivyotengenezwa na AI pekee vitahifadhiwa. Vipengele vingine vyote vitaondolewa kwenye ukurasa.',
    generate_story: 'Tengeneza Hadithi',
    save_original_content: 'Hifadhi maudhui ya asili:',
    story_added_specified_position:
      'Nafasi ya hadithi ndani ya somo. Hadithi itaongezwa kama kipande katika nafasi uliyochagua.',
    position_of_story: 'Nafasi ya Hadithi',
    start_the_lesson: 'Mwanzo wa Somo',
    end_the_lesson: 'Mwisho wa Somo',
    add_story_pages: 'Ongeza Hadithi kwenye Kurasa',
    browser_does_not_support:
      'Kivinjari chako hakihusiani na kipengele cha sauti.',
    no_video_available: 'Hakuna video zilizopo.',
    no_podcast_available: 'Hakuna podikasti zilizopo.',
    no_item_baskets: 'Hakuna vitu kwenye kikapu.',
    ai_course_object: 'Kuongoza katika enzi ya kidijitali'
  },
  v2: {
    n_data: 'Hakuna Data',
    change: 'Badilisha',
    remove: 'Ondoa',
    auto_background: 'Mandharinyuma Kiotomatiki',
    create_new_course_org: 'Unda kozi mpya kwa shirika lako.',
    create_new_course_marketplace: 'Unda kozi mpya kwa soko.',
    create_new_course_both: 'Unda kozi mpya kwa shirika lako na soko.',
    ok: 'Sawa',
    page_bg: 'Mandharinyuma ya Ukurasa',
    lesson_cover: 'Picha ya Jalada la Somo',
    create_skill_journey: 'Unda Safari ya Ujuzi',
    Metamaze: 'Metamaze',
    events: 'Matukio',
    scroms: 'SCORMs',
    min_score_pass: 'Alama ya Chini Kupita',
    no_scorms_available: 'Hakuna SCORMs zinazopatikana.',
    no_events_available: 'Hakuna matukio yanayopatikana.',
    no_courses_available: 'Hakuna kozi zinazopatikana.',
    no_courses_baskets: 'Hakuna kozi kwenye kapu.',
    no_mazes_baskets: 'Hakuna maze kwenye kapu.',
    no_scroms_baskets: 'Hakuna SCORMs kwenye kapu.',
    no_events_baskets: 'Hakuna matukio kwenye kapu.',
    sorry: 'Pole!',
    option_1: 'Chaguo 1',
    option_2: 'Chaguo 2',
    enter_number_words: 'Weka idadi ya juu ya maneno.',
    summarize: 'Fupisha',
    answer: 'Jibu',
    hold_tight_one_minute:
      'Subiri tafadhali! Tunajiandaa bado. Hii inaweza kuchukua hadi dakika moja.',
    enter_question: 'Weka swali lako.',
    enter_relevant_documents: 'Weka idadi ya nyaraka muhimu.',
    please_input_relevant_documents: 'Tafadhali weka idadi ya nyaraka muhimu!',
    please_wait_loading_results: 'Tafadhali subiri matokeo yanapopakizwa...',
    proceed_to_add_voice: 'Endelea Kuongeza Sauti',
    results: 'Matokeo',
    no_result_found_try_asking_questions:
      'Hakuna matokeo yaliyopatikana. Jaribu kuuliza maswali zaidi.',
    eg: 'mf.,',
    what_make_sales_manager: 'Ninawezaje kuwa meneja wa mauzo?',
    please_select_lang: 'Tafadhali chagua lugha yoyote!',
    search: 'Tafuta',
    please_copy_desired_content:
      'Tafadhali nakili maudhui unayoyataka kutoka kisanduku cha kushoto hadi kulia.',
    rating_req: 'Ukadiriaji ni lazima.',
    review_req: 'Mapitio ni lazima.',
    rating_review_req: 'Lazima utoe ukadiriaji na mapitio.',
    how_rate_this: 'Ungekadirije hili?',
    amazing_above_expectations: 'Ajabu! Zaidi ya matarajio!',
    certificates: 'Vyeti',
    you_no_certificates: 'Huna vyeti vinavyopatikana kwa sasa.',
    please_add_review: 'Tafadhali toa mapitio pamoja na ukadiriaji. Asante!',
    post: 'Chapisha',
    rate: 'Kadiria',
    avg_rating: 'Ukadiriaji wa Wastani',
    no_review_found: 'Hakuna Mapitio Yaliyopatikana',
    are_sure_to_disale_zoom_integration:
      'Una uhakika unataka kuzima muunganiko wa Zoom?',
    badges: 'Beji',
    you_no_badge_available: 'Huna beji zinazopatikana kwa sasa.',
    download_certificate: 'Pakua Cheti',
    loading: 'Inapakia...',
    no_file_attached: 'Hakuna Faili Iliyowekwa',
    you_do_not_have_any_notes: 'Huna maelezo yoyote.',
    question: 'Swali',
    score: 'Alama',
    alert_score_message: 'Mtu au watu wamewasilisha alama zao.',
    alert_question_message: 'Hakuna maswali yaliyoongezwa hadi sasa.',
    button_submit: 'Wasilisha',
    button_allScores: 'Alama zote zimewasilishwa.',
    record_wait: 'Rekodi inaanza. Tafadhali subiri...',
    buttonSubmit_warning: 'Tafadhali weka alama zote kabla ya kuwasilisha.',
    upload_ar_assets: 'Pakia Mali za AR',
    edit_ar_assets: 'Hariri Mali za AR',
    edit_maze_assets: 'Hariri Mali za MetaMaze',
    upload_assets: 'Pakia Mali',
    upload_maze_assets: 'Pakia Mali za MetaMaze',
    trigger_title: 'Kichwa cha Kichocheo',
    model_title: 'Kichwa cha Mfano',
    trigger_description: 'Maelezo ya Kichocheo',
    model_description: 'Maelezo ya Mfano',
    please_type_target_description: 'Tafadhali andika maelezo ya lengo.',
    please_type_model_description: 'Tafadhali andika maelezo ya mfano.',
    trigger_image: 'Picha ya Kichocheo*',
    model_image: 'Picha ya Mfano*',
    upload_trigger_image: 'Pakia Picha ya Kichocheo',
    upload_model_image: 'Pakia Picha ya Mfano',
    drag_n_drop: 'Vuta na Acha',
    file_size_should_not_exceed:
      '(Saizi ya Faili la Picha (JPEG) haipaswi kuzidi 512 KB)',
    zip_size_should_not_exceed: '(Saizi ya Faili la ZIP haipaswi kuzidi 60 MB)',
    ar_content: 'Yaliyomo ya AR*',
    model_content: 'Mfano wa 3D*',
    upload_3d_zip: 'Pakia ZIP / Video',
    upload_3d_maze_zip: 'Pakia ZIP',
    audio_content: 'Yaliyomo ya Sauti',
    _mp3: '(.mp3)',
    content_attached: 'ZIP Imesambazwa.',
    video_attached: 'Video Imeambatanishwa.',
    audio_attached: 'Sauti Imeambatanishwa.',
    enter_trigger_image_title: 'Ingiza kichwa cha picha ya kichocheo.',
    enter_model_title: 'Ingiza kichwa cha mfano wa MetaMaze.',
    ar_preview_image: 'Picha ya Awali ya AR',
    upload_preview_image: 'Pakia Picha ya Awali',
    upload_audio: 'Pakia Sauti',
    creating___: 'Inaunda...',
    updating___: 'Inasasisha...',
    create: 'Unda',
    update: 'Sasisha',
    ar_assets: 'Picha ya 3D',
    _3d_files_mp4: '(Faili zilizo kwenye ZIP .obj, .fbx au Video .mp4)',
    _3d_files_mp4_ar: '(Faili zilizo kwenye ZIP .obj, .fbx)',
    maze_3d_files_mp4: '(Faili zilizo kwenye ZIP .obj, .fbx)',
    _jpg_files: 'Inasaidia tu .jpg',
    persons_have_submitted_their_scores: 'Mtu/Mtu wamewasilisha alama zao.',
    no_questions_added_till_now: 'Hakuna maswali yaliyoongezwa hadi sasa.',
    submit: 'Tuma',
    all_scores_submitted: 'Alama zote zimetumwa.',
    recording_is_starting: 'Kurekodi kunaanza. Tafadhali subiri...',
    please_input_scores_before_submitting:
      'Tafadhali ingiza alama zote kabla ya kutuma.',
    end_for_all: 'Maliza kwa Wote',
    full_screen: 'Skrini Kamili',
    breakout_room: 'Chumba cha Mkutano',
    send_invitations: 'Tuma Mwaliko',
    add_participants: 'Ongeza Washiriki',
    create_breakout_room: 'Unda Chumba cha Mkutano',
    connecting: 'Inakuza...',
    currently_broadcaster_unavailable: 'Kwa sasa, mtangazaji hayupo.',
    how_many_breakout_room_to_create:
      'Unataka kuunda vyumba vingapi vya mkutano?',
    create_upto_three_breakout_rooms: '*Unda Vyumba vya Mkutano hadi 3',
    allow: 'Ruhusu',
    additional: 'Zaidi',
    attachment: 'Viambatisho',
    no_description_available: 'Hakuna maelezo yanayopatikana.',
    people: 'WATU',
    waiting: 'Kunasubiri',
    hand_raising_users: 'Watumiaji wanaoinua mikono',
    invite: 'Mwaliko',
    create_room: 'Unda Chumba',
    create_live_event: 'Unda Tukio la Moja kwa Moja',
    support_upto_fivethousand_participants:
      'Inaunga mkono washiriki hadi 5,000 kwa tukio',
    support_upto_ten_participants:
      'Inaunga mkono washiriki 10 wa video moja kwa moja',
    support_upto_twohundred_participants:
      'Inaunga mkono washiriki hadi 200 kwa tukio',
    supprt_upto_five_participants:
      'Inaunga mkono washiriki 5 wa video moja kwa moja',
    support_upto_twentyfive_participants:
      'Inaunga mkono washiriki 25 wa video moja kwa moja kwa tukio',
    two_live_video_participants:
      'Kuna washiriki 2 wa video moja kwa moja kwa tukio (mwenyeji na mshiriki)',
    you_can_have_upto_five_examinees: 'Unaweza kuwa na wachunguzi hadi 5 tu.',
    you_can_have_upto_twentyfive_participants:
      'Unaweza kuwa na washiriki hadi 25 tu.',
    you_can_have_upto_five_participants: 'Unaweza kuwa na washiriki hadi 5 tu.',
    you_can_have_upto_ten_participants: 'Unaweza kuwa na washiriki hadi 10 tu.',
    select_hosts_email: 'Chagua Barua Pepe ya Mwenyeji',
    send_invite_email: 'Tuma Barua Pepe ya Mwaliko',
    do_not_send_invite_email: 'Usitume Barua Pepe ya Mwaliko',
    error: 'Hitilafu',
    max_twentyfive_users_allowed: 'Watumiaji 25 pekee wanaruhusiwa kuchaguliwa',
    max_five_users_allowed: 'Watumiaji 5 pekee wanaruhusiwa kuchaguliwa',
    max_ten_users_allowed: 'Watumiaji 10 pekee wanaruhusiwa kuchaguliwa',
    no_user_found: 'Hakuna Mtumiaji Aliye Patikana',
    transcribe_to: 'Tafsiri kwa',
    integrate_zoom_to_start_meeting:
      'Unganisha Zoom kwenye akaunti yako kuanza mkutano wa Zoom.',
    zoom_is_not_integrated: 'Zoom haijajumuishwa.',
    delete_poll: 'Futa Utafiti',
    add_poll: 'Ongeza Utafiti',
    live_now: 'INAENDELEA SASA!',
    average_rating: 'Kiwango cha Kiwango',
    review: 'Maoni',
    time_spent: 'Muda ulio tumika',
    total: 'Jumla',
    mins: 'Dakika',
    no_data: 'Hakuna data kwa ajili ya jaribio hili.',
    total_score: 'Jumla ya Alama',
    pass_score: 'Alama ya Kupita',
    point: 'Alama',
    wrong: 'Siyo Sahihi',
    response: 'Majibu',
    submitted: 'Imetumwa',
    average: 'Wastani',
    total_play: 'Jumla ya Kucheza',
    view_graph: 'Tazama Grafu',
    time_spent_mins: 'Muda Uliotumika (Dakika)',
    play: 'Cheza',
    ideal_path: 'Njia Bora',
    user_incorrect_path: 'Njia Isiyofaa ya Mtumiaji',
    ideal_path_taken: 'Njia Bora Iliyochukuliwa na Mtumiaji',
    scenario: 'Muktadha',
    option: 'Chaguo',
    spend: 'Matumizi',
    average_spending_time: 'Muda Wastani wa Matumizi',
    activity_overview: 'Muhtasari wa Shughuli',
    live_event: 'Tukio la Moja kwa Moja',
    live_assessment: 'Tathmini ya Moja kwa Moja',
    report_download: 'Pakua Ripoti',
    all_workshops: 'Warsha Zote',
    overview_average_activity: 'Muhtasari wa Shughuli ya Wastani',
    overview_workshop_graph: 'Grafu ya Muhtasari wa Warsha',
    mazes: 'Mazoea ya Labirinth',
    correct_feedback: 'Maoni Sahihi',
    incorrect_feedback: 'Maoni Yasiyo Sahihi',
    checkin_checkout: 'Kuingia - Kutoka',
    minutes: 'Dakika',
    incorrect_path: 'Njia Isiyo Sahihi',
    answer_not_available: 'Jibu Halipatikani',
    views: 'Maoni',
    item: 'Kipengee',
    questions: 'Maswali',
    total_points: 'Jumla ya Pointi',
    total_attempts: 'Jumla ya Jaribio',
    created_date: 'Tarehe Iliyoundwa',
    host_name: 'Jina la Mwangaza',
    host_section: 'Sehemu ya Mwangaza',
    choose_products: 'Chagua Bidhaa',
    add_to_basket: 'Ongeza kwenye Kikapu',
    basket: 'Kikapu',
    times: 'Mara',
    scorms: 'SCORMs',
    skill_journey_overview: 'Muhtasari wa Safari ya Ujuzi',
    how_to_use: 'Jinsi ya Kutumia',
    live_broadcast_description:
      'TUMEBADILI VIDEO YA MOJA KWA MOJA KATIKA MJENGEZI WA KOZI RAHISI KUTUMIA',
    live_broadcast_subdescription:
      'Kwa mfumo wa moja kwa moja wa matangazo wa ShareLook, unaweza kuunda ushirikishwaji, kuendesha mafunzo moja kwa moja, na kuongeza ujuzi unaoshirikiwa.',
    disclaimer: `Nina hakikisho kuwa safari yangu ya ujuzi haitakuwa:
  - kuathiri haki za mtu mwingine
  - kuwa na maudhui yasiyokubalika, ikiwa ni pamoja na kashfa, machafu, ukatili, uvunjifu wa heshima, au maudhui ya kibaguzi hata kama yamefichwa na nyota
  - kushambulia mtu mwingine binafsi
  - kujitambulisha kwa udanganyifu kama mtu mwingine, watu mashuhuri au watu wa umma
  - kuwa na rekodi au taarifa binafsi za mtu bila idhini yao na haivunji sheria yoyote ya ulinzi wa data duniani
  - kuwa na matangazo ya kibiashara au aina yoyote ya “spam”`,
    price: 'Bei',
    video_link: 'Kiungo cha Video',
    category: 'Kategoria',
    objectives: 'Malengo',
    marketplace_description: 'Maelezo ya Soko',

    live_discussion: 'MJADALA WA MOJA KWA MOJA',
    poll: 'UCHAGUZI',
    hide_grid: 'Ficha Gridi',
    show_grid: 'Onyesha Gridi',
    stop_screen_share: 'Acha Kushiriki Skrini',
    screen_share: 'Shiriki Skrini',
    mute: 'Zima Sauti',
    unmute: 'Washa Sauti',
    raise_hand: 'Inua Mkono',
    waiting__: 'Inasubiri...',
    audio_active: 'Sauti Inaendelea'
  },
  general: {
    save: 'hifadhi',
    autosaved: 'Iliyohifadhiwa',
    back_to: 'Rudi kwa',
    by: 'Na',
    chat: 'maongezi',
    completed: ' Imekamilika',
    canceled: 'Imeghairiwa',
    component: 'Kijenzi',
    confirm: ' thibitisha',
    course: ' kozi',
    skill: 'Safari ya Ujuzi',
    maze: 'MetaMaze',
    channel: 'Kituo',
    podcast: 'Podcast',

    date: 'Tarehe',
    details: ' Maelezo',
    empty: ' Hakuna data',
    enrolled: 'Umejiandikisha',
    free: ' Bure',
    graph: 'Grafu',
    loading: 'Inapakia...',
    lesson: 'somo',
    lessons: 'masomo',
    live_assessment: 'Tathmini ya moja kwa moja',
    live_event: 'Tukio la moja kwa moja',
    no: ' Hapana',
    of: 'Ya',
    or: 'Au',
    organization: 'Shirika',
    page: ' Ukurasa',
    pages: 'Kurasa',
    personal: ' Binafsi',
    poll: 'Kura',
    rating: ' Ukadiriaji',
    reset: 'Weka upya',
    signin: 'Ingia',
    signup: 'Jisajili',
    soon: 'Hivi karibuni',
    type: 'Piga chapa',
    uploading: ' Inapakia...',
    yes: 'Ndio',
    something_went_wrong: 'Kuna kitu kimeenda vibaya!',
    view_all: 'Tazama zote',
    upload_successful: 'kupakia kumefanikiwa',
    upload_successful_message:
      ' Nyaraka zako bora zimepakiwa vizuri na sasa inashughulikiwa. Hii inaweza kuchukua muda.',
    check_email_upload_successful:
      'Tafadhali <0> angalia barua pepe yako </0> kwa ripoti ya <1> </1> ya orodha ya watumiaji waliyopakiwa',
    is_private: 'Binafsi'
  },

  account: {
    title: 'Akaunti',
    subtitle: 'Simamia mipangilio yako na habari ya akaunti.',
    saved: 'Akaunti ilibadilishwa vizuri'
  },

  assessments: {
    title: 'Tathmini',
    subtitle: 'Unda tathmini',
    finished: 'Tathmini imekamilika',
    countdown: 'Tathmini ya moja kwa moja itakuwa ikitangaza kwa',
    create: 'Unda Tathmini',
    list_title: 'Tathmini zako',
    delete_warning: 'Una uhakika unataka kufuta jambo hili?',
    details_title: 'Ongeza Maelezo ya Tathmini',
    details_subtitle:
      'Taja tathmini yako na uwaambie watazamaji wako kile wanachotarajia kujifunza kutoka kwake.',
    disclaimer: `Niagiza kwamba tathmini yangu iliyorekodiwa haitafanya:
     - kukiuka haki za mtu yeyote wa tatu
     - Inayo uharamia wowote, pamoja na uchafu
     - Inashambulia mtu yeyote kwa watu wengine
     - Inayo uigaji wowote wa washiriki wengine, takwimu za umma au watu mashuhuri
     - Inayo habari yoyote ya kurekodi au ya kibinafsi kwa mtu yeyote bila idhini ya mtu huyo na haiko katika ukiukaji wa sheria yoyote ya ulinzi wa data katika sehemu yoyote ya ulimwengu
     - Inayo rufaa ya kibiashara au aina yoyote ya "barua taka”'`,

    // added_first
    assessment_details: 'maelezo ya tathmini',
    assessment_settings: 'mipangilio ya tathmini'
  },

  buildersettings: {
    title: 'mipangilio ya kuchapisha',
    subtitle:
      'Ongeza mipangilio kwenye hafla yako, ambaye anaweza kutazama na kuingiliana na tukio lako'
  },

  buttons: {
    market_place: 'Market Place',
    back_to_normal: 'Back To Normal',
    add: 'Ongeza',
    add_page: 'Ongeza ukurasa',
    add_lesson: 'Ongeza masomo',
    add_answer: 'Ongeza jibu mpya',
    add_group: 'Ongeza Kikundi',
    add_organization: 'Ongeza Shirika',
    add_question: 'Ongeza swali',
    add_quiz: 'Ongeza Jaribio',
    add_users: 'Ongeza Watumiaji',
    back: ' Nyuma',
    back_to_course: 'Rudi kwa muhtasari wa kozi',
    back_to_lesson: 'Rudi kwenye muhtasari wa somo',
    back_to_media: 'Rudi kwenye Maktaba ya Media',
    back_to_details: 'Rudi kwenye maelezo',
    cancel: 'Ghairi',
    clear: 'Futa',
    close: 'Funga',
    clone: 'Clone',
    close_lesson: 'Funga Somo',
    clone_course: ' Kozi ya Clone',
    confirm: 'Thibitisha',
    create: 'Unda',
    download: 'Pakua',
    download_mass_user_template: ' Pakua Kiolezo',
    add_mass_users: 'Ongeza Watumiaji wengi',
    upload_excel_list: 'Pakia Orodha ya Excel',
    delete: 'Futa Media',
    edit: 'Hariri',
    edit_course: 'Harir kozi',
    enroll: 'Jiandikishe',
    finish: 'Maliza',
    upload_image: 'Pakia picha',
    upload_image_video: 'Pakia picha au video',
    select_media_library: 'Chagua maktaba ya media',
    make_public: 'Fanya Umma',
    make_private: 'Fanya faragha',
    make_org: 'Fanya ya Shirika',
    media: 'Maktaba ya Media',
    my_theme: 'Mada yangu',
    next: 'Ifuatayo',
    next_lesson: 'Somo lifutalo',
    next_step: 'Hatua ifuatayo',
    previous_step: 'Hatua iliyotangulia',
    publish: 'Chapisha',
    publish_assessment: 'Chapisha tathmini yako',
    publish_course: 'Chapisha kozi yako',
    publish_event: 'Chapisha tukio lako',
    reset: 'Weka upya',
    reset_elements: 'Rudisha vipengee',
    save: 'Hifadhi',
    creating: 'Inaunda...',
    updating: 'Inasasisha...',
    saved: 'Imehifadhiwa',
    save_for_later: 'Hifadhi kwa baadaye',
    save_settings: 'Hifadhi mipangilio',
    select_files: 'Chagua faili',
    select_theme: 'Chagua mandhari',
    start_lesson: 'Anza Somo',
    update: 'Sasisha',
    upload: 'Pakia',
    upload_audio: 'Pakia Sauti',
    upload_photo: 'Pakia picha ya wasifu',
    upload_video: 'Pakia Video',
    enrolled: 'Umeandikishwa',
    unenroll: 'Sijiandikishe',
    from_library: 'Maktaba ya Media',
    remove: 'Ondoa',
    removed: 'Imeondolewa',
    start_broadcast: 'Anza Matangazo',
    end_broadcast: 'Maliza Matangazo',
    camera: 'Kamera',
    screen: 'Skrini',
    screen_with_camera: 'Skrini na Kamera',

    // added_first
    insert: 'Ingiza',
    inserting: 'Inaingiza'
  },

  card: {
    quick_add: 'Ongeza haraka',
    add: 'Ongeza',
    clone: 'Clone',
    completed: 'masomo yamekamilika'
  },

  course: {
    upcoming_course: 'Kozi inayokuja',
    unPublishEvent: 'Sichapishe Tukio',
    unPublishAssessment: 'Sichapishe Tathmini',
    pastCourse: 'Kozi ya Mafunzo',
    upcoming: 'Tukio lijalo la Moja kwa Moja',
    pastEvent: 'Tukio la Moja kwa Moja la zamani',
    pastAssessment: 'Tathmini ya Moja kwa Moja ya zamani',
    upcomingAssessment: 'Tathmini inayokuja ya Moja kwa Moja',
    created: 'Tarehe Iliyoundwa:',
    assignees: 'Waliopangiwa',
    organisations:
      ' {{mashirika}} mashirika   <2> {{watumiaji]} watumiaji </2>',
    event_date: 'Tarehe ya tukio moja kwa moja <1> {{tarehe}} </1>',
    delete_warning: 'Una uhakika unataka kufuta hii',
    clonning_no_lesson:
      'Tafadhali ongeza Somo moja angalau ili uclone kozi hii.',
    clone_warning: 'Una uhakika unataka kuclone hii',
    clone_success: 'iko kwenye mchakato wa clone',
    disclaimer: `Ninahakikisha kwamba kozi yangu haifanyi:
     - kukiuka haki za mtu yeyote wa tatu
     - Inayo uharamia wowote   pamoja na uchafu
     - Inashambulia mtu yeyote kwa watu wengine
     - Inayo uigaji wowote wa washiriki wengine   takwimu za umma au watu mashuhuri
     - ina habari yoyote ya kibinafsi kwa mtu yeyote bila idhini ya mtu huyo na sio kwa kukiuka kanuni yoyote ya ulinzi wa data katika sehemu yoyote ya ulimwengu
     - Inayo rufaa yoyote ya kibiashara au aina yoyote ya "barua taka”`
  },

  coursecreate: {
    dropzone_text: 'Ingiza media',
    sidebar_text: 'Chagua mada <1 /> kwa <3 /> masomo yako',
    delete_warning: 'Je! Una uhakika unataka kufuta somo hili?'
  },

  coursepage: {
    quizview_loading: 'Inaangalia majibu. Tafadhali subiri...',
    quizview_answer: ' Jibu lako'
  },

  coursequiz: {
    title: 'Jaribio katika Masomo yote'
  },

  dashboard: {
    tooltip_title: 'Usionyeshe video hii tena',
    page_title: 'Takwimu za kozi Zako',
    page_subtitle: 'Hali ya kozi ulizounda',
    profile_add_info:
      ' Ongeza <1> {{Nakala isiyokamilika}} </1> kukamilisha wasifu wako.',
    profile_build:
      'Jenga wasifu wako <1> hapa </1>   tujulishe mambo unayopenda na ujuzi.',
    profile_title: 'Nguvu ya wasifu',
    more_details: 'Maelezo Zaidi'
  },

  errors: {
    answer: 'Tafadhali jibu',
    answer_correct: 'Chagua jibu sahihi',
    code: 'Tafadhali ingiza nambari yako',
    criterion: 'Tafadhali ingiza kigezo',
    duration: 'Muda unahitajika',
    element: 'Tafadhali ingiza kipengee',
    email: 'Tafadhali ingiza barua pepe yako',
    email_invalid: 'Ingizo sio barua pepe halali',
    feedback_correct: 'Tafadhali ingiza maoni sahihi',
    feedback_incorrect: 'Tafadhali ingiza maoni sio sahihi',
    host: 'Tafadhali ingiza mwenyeji wa hafla ya tukio',
    host_assessment: 'Tafadhali ingiza tathmini ya mwenyeji',
    image: 'Tafadhali pakia picha',
    location: 'Tafadhali ingiza eneo lako',
    live_location: 'Tafadhali chagua eneo la utangazaji',
    limit: 'Tafadhali ingiza dakika za kusambaza moja kwa moja',
    min_3char: 'isipungue herufi tatu',
    number: 'tafadhali ingiza nambari chanya.',
    host_email_require: `Barua pepe za mwenyeji zinahitajika.`,
    attendee_email_require: `Barua pepe za waliohudhuria zinahitajika.`,
    name: 'Tafadhali ingiza jina lako',
    not_found_course: 'Kozi haipatikani',
    not_found_event: 'Tukio halikupatikani',
    not_found_assessment: 'Tathmini haipatikani',
    password: 'Tafadhali ingiza nenosiri lako',
    password_digit: 'Angalau tarakimu moja',
    password_short: 'Nenosiri ni fupi sana, ispungue herufi 10',
    password_special: 'Angalau herufi moja maalum',
    password_uppercase: 'Angalau herufi moja kubwa',
    password_lowercase: 'Angalau herufi moja ndogo',
    phone: 'Tafadhali ingiza nambari yako ya simu yako',
    phone_invalid: 'Nambari batili ya simu',
    position: 'Tafadhali ingiza msimamo wako',
    question: 'Tafadhali ingiza swali',
    start_date: 'Tarehe ya kuanza na Wakati unahitajika',
    tag: 'Tafadhali chagua tepe',
    topics: 'Tafadhali chagua mada angalau moja.',
    live_topics: 'Tafadhali ongeza mada',
    title: 'Tafadhali ingiza kichwa',
    title_assessment: 'Tafadhali ingiza kichwa cha tathmini',
    title_course: 'Tafadhali ingiza kichwa cha kozi',
    title_empty: 'Kichwa hakiwezi kuwa tupu',
    title_event: 'Tafadhali ingiza kichwa cha tukio',
    title_lesson: 'Tafadhali ingiza kichwa cha somo',
    title_quiz: 'Tafadhali ingiza jina la jaribio',
    username: 'Tafadhali ingiza jina lako la mtumiaji',
    upload_error: 'Kosa - Faili haifai!',
    upload_more_than_10: 'Unaweza kupakia faili kumi tu mara moja.',
    topics_max: 'Tafadhali ongeza mada tatu tu pekee.',
    upload_excel: 'Tafadhali hakikisha umepakia faili sahihi.',
    title_excel: 'Kosa la kupakia templeti:',
    file_size_exceed: 'Saizi ya faili inazidi',
    subtitle_excel:
      'Tafadhali hakikisha kutumia templeti iliyotolewa na nguzo zimejazwa kwa usahihi.',
    select_broadcast_option: 'Tafadhali chagua chaguo kutangaza tukio hili',
    multi_hosts_number_error:
      'Nambari ya mwenyeji hayawezi kuzidi kuliko ilivyoainishwa kwa hafla hiyo.',
    conference_people_number_error: `Nambari ya mtangazaji hayawezi kuzidi kuliko ilivyoainishwa kwa hafla hiyo.`,
    select_max_host: 'Chagua mtangazaji angalau moja kwa hafla hiyo.',
    select_max_conference: 'Chagua angalau mhudumu mmoja wa tukio hilo.',
    stream_stop_error: 'Inajaribu kuunganisha tena...',
    no_stream_error: 'Inasubiri mwenyeji kuanza tukio',
    unsecure_context:
      'Kosa mbaya: Kivinjari hakiwezi kupata kamera na mic kwa sababu ya muktadha wa usalama. Tafadhali sasisha SSL na ufikie kupitia https',
    ws_not_supported:
      'Kosa mbaya: WebSocket haijaungwa mkono katika kivinjari hiki',

    // added_first
    no_org: 'Chagua angalau shirika 1 kuendelea.',
    no_org_group: 'Chagua angalau kikundi cha shirika 1 kuendelea.',
    waiting_to_join: 'Inasubiri mtu ajiunge!'
  },

  events: {
    title: 'Ongeza Maelezo ya Tukio Moja kwa Moja',
    change_host: 'Badilisha mtangazaji',
    finished: 'Tukio limekamilika',
    countdown: 'Tukio la moja kwa moja litatangaza kwa',
    subtitle:
      'Lipe jina tukio lako la Moja kwa moja na uwaambie watazamaji wako kile wanatarajia kujifunza kutoka kwako.',
    poll_disabled: 'Kura haipatikani katika hafla hii',
    disclaimer: `Niagiza kwamba hafla yangu iliyorekodiwa haitafanya:
    - kukiuka haki za mtu yeyote wa tatu
  - Inayo uharamia wowote   pamoja na uchafu
  - Inashambulia mtu yeyote kwa watu wengine
  - Inayo uigaji wowote wa washiriki wengine   takwimu za umma au watu mashuhuri
  - Inayo habari yoyote ya kurekodi au ya kibinafsi kwa mtu yeyote bila idhini ya mtu huyo na haiko katika ukiukaji wa sheria yoyote ya ulinzi wa data katika sehemu yoyote ya ulimwengu
  - Inayo rufaa ya kibiashara au aina yoyote ya "barua taka"`,
    prompt_message:
      'Kuondoka kwenye ukurasa huu utamaliza hafla yako. Una uhakika wa kuacha ukurasa huu?',
    duration_exceed_message:
      ' Wakati wako wa utangazaji unazidi  App itaacha kutangaza.',
    before_schedule_message:
      'Uko karibu kuanza utangazaji kabla ya wakati wa tukio uliopangwa. Tafadhali kumbuka kuwa kuzuia utangazaji kumaliza tukio.',
    browser_unsupportive_message:
      'Kivinjari chako hakiingiliani na kushiriki skrini. Unaweza kuona vivinjari vilivyoungwa mkono kwenye kiunga hiki',
    cancel_switch_host_message:
      'Mwenyeji halipatikani. Hafla hiyo itaendelea kutoka kwako.',
    coaching_prompt_message:
      'Hauwezi kuacha ukurasa huu hadi tukio litakapokamilika.',
    event_modal_warn: 'Je! Unataka kuacha tukio hili?',
    confirm_message: 'Tukio lako litaisha ikiwa bonyeza Ndiyo.',
    screen_share_denied: 'Umekataa kushiriki skrini yako',
    media_not_found:
      'Kamera au Mic hazipatikani au haziruhusiwi kwenye kifaa chako.',
    media_not_access:
      'Kamera au Mic inatumiwa na michakato mingine ambayo hairuhusu kusoma vifaa',
    constraint_error:
      'Hakuna kifaa kilichopatikana kinacholingana na vizuizi vya video na sauti. Unaweza kubadilisha vizuizi vya video na sauti',
    media_access_denied: 'Hauruhusiwi kupata kamera na mic.'
  },

  filters: {
    days7: 'Siku 7 zilizopita',
    days15: 'Siku 15 zilizopita',
    days30: 'Siku 30 zilizopita',
    days365: 'Siku 365 za zilizopita',
    date: 'Tarehe iliyoundwa',
    relevance: 'Umuhimu',
    popularity: ' Umaarufu',
    name: 'Jina',
    group: 'Kikundi',
    Newest_to_Oldest: 'Mpya zaidi kwa zee zaidi',
    Oldest_to_Newest: 'zee zaidi kwa Mpya zaidi',
    A_Z: 'A hadi Z',
    Z_A: 'Z hadi A'
  },

  helpers: {
    password:
      'Ili kuhakikisha usalama wa akaunti yako tunahitaji angalau alama ndogo moja   nambari yako katika nenosiri lako. Unahitaji pia kuwa na urefu wa chini wa herufi 10.',
    phone: 'Tafadhali weka nambari yako ya nchi ya simu kwa mfano: +65',
    username:
      'Jina lako la mtumiaji linatibiwa kama habari ya umma na hushirikiwa na watumiaji wengine kama inahitajika. Kama hivyo   tunapendekeza usitumie habari za kibinafsi katika jina lako la mtumiaji',
    public_description_normal:
      'Yako <0><0/> </0> imehifadhiwa na inachukuliwa kuwa ya faragha kwa msingi. Hii inamaanisha kuwa wewe tu unaweza kuona maudhui haya. Ili kuchapisha maudhui haya unaweza kuchagua moja ya chaguzi hapa chini. Kuchapisha kozi yako kwa Umma kunamaanisha kuwa itapatikana kwa watumiaji wote kwenye jukwaa. Chaguo Maalum la Watumiaji litakuwezesha kushiriki kozi yako na watumiaji maalum kwa kutumia anwani ya barua pepe inayohusiana na akaunti yao ya Shiriki.',
    public_description_admin:
      'Hii <0><0/> </0> imehifadhiwa na inachukuliwa kuwa ya faragha kwa msingi. Hii inamaanisha kuwa wewe tu (na muundaji wa yaliyomo) ndiye anayeweza kuona maudhui haya. Ili kuchapisha maudhui haya unaweza kuchagua moja ya chaguzi hapa chini. Kuchapisha kozi yako kwa Umma kunamaanisha kuwa itapatikana kwa watumiaji wote kwenye jukwaa - pamoja na wale walio nje ya shirika lako. Kuichapisha kwa shirika kunamaanisha kuwa watumiaji wote ndani ya shirika wataweza kuiona. Unaweza kuichapisha kwa vikundi 1 au zaidi   ikimaanisha watumiaji tu kwenye vikundi hivyo wataweza kuiona. Mwishowe   una chaguo la kuchapisha kwa watumiaji maalum ndani na nje ya shirika lako kwa kutumia anwani yao ya barua pepe ya akaunti ya ShareLook.'
  },

  labels: {
    add: 'Ongeza',
    portrait: 'Crop Portrait',
    landscape: 'Crop Landscape',
    answer_type: 'Aina ya Jibu',
    answers: 'Majibu',
    back_to_quiz: 'Rudi kwenye orodha ya jaribio',
    back_to_question: 'Rudi kwenye orodha ya maswali',
    chat: 'Maongezi',
    chat_available: 'Maongezi haipatikani katika hafla hii',
    chat_report: 'Ripoti ya maongezi',
    choice_single: 'Chaguo moja',
    choice_multiple: 'Chaguo nyingi',
    choice_free: '"chaguo lolote "',
    choice_sorting: '"chaguo la Kuamua"',
    choice_matrix: '"chaguo la Matrix"',
    clone_lesson_permission: 'Ruhusa ya Clone',
    code: 'Code',
    correct: 'Sahihi',
    created: 'Tarehe iliyoundwa',
    clone_modal: 'Clone kozi',
    cloning_course: 'Inaclone Kozi...',
    cloning: 'Cloning...',
    cloning_course_desc:
      'Mchakato huu utachukua muda. Tafadhali kuwa na subira',
    cloning_success: 'Kozi" <0 /> "imeumbwa kwa usawa!',
    description: 'Maelezo',
    disclaimer: 'Kanusho',
    drop_file: 'Weka faili hapa...',
    duration: ' Muda',
    edit: 'Hariri',
    email: 'barua pepe',
    event: 'Tukio',
    event_all: 'Matukio yake yote',
    event_date: 'Wakati na tarehe ya kawaida ya Tukio la Moja kwa moja',
    event_this: 'Hafla hii',
    expire: 'Kuisha kwa',
    expiry_date: 'Tarehe ya mwisho wa matumizi',
    forgot: 'Umesahau nenosiri?',
    group: 'Kikundi',
    groups_list: 'Orodha ya Vikundi',
    host: 'mwenyeji',
    id_annotation: 'Annotation id',
    id_number: 'nambari ya kitambulisho',
    id_quiz: 'Kitambulisho cha jaribio',
    incorrect: 'Sio sahihi',
    interests: 'masilahi',
    invited: 'Umealikwa',
    live_chat: 'Majadiliano ya moja kwa moja',
    live_stream_limit: 'Dakika za Kutiririka Moja kwa Moja',
    contact_text:
      'Ili kubadilisha kikomo chako cha utiririshaji wa moja kwa moja tafadhali wasiliana',
    contact_admin:
      '<0> Ikiwa unataka kubadilisha kikomo chako cha kutiririsha matangazo moja kwa moja tafadhali wasiliana </0> <1> admin@shareview.com </1>',
    limit_stream_text:
      'Dakika zilizosambaa kwa Moja kwa Moja: <0> {{kikomo}} </0> dakika <1 /> <2 /> <3> Ili kubadilisha kikomo chako cha kusisimua moja kwa moja tafadhali wasiliana na </3> <4> admin @ shareLook.com </4>',
    location: ' Mahali',
    lessons: 'Masomo',
    location_broadcast: 'Mahali pa Seva ya Wasimamizi',
    location_broadcast_subtitle:
      'Ongeza eneo ambalo karibu zaidi na eneo la mwenyeji wa matangazo ili kupunguza kuchelewesha kwa sauti',
    media_manager: 'Meneja wa media',
    minutes: 'Dakika',
    name: 'Jina',
    online_quiz: 'Jaribio Mtandaoni',
    organiser: 'Mwandishi',
    organization: 'Shirika',
    overall_emotion: 'Uzoefu wa Jumla:',
    organizations_list: 'Orodha ya mashirika',
    password: 'Nenosiri',
    participants: 'Washiriki',
    picture: 'Picha (16:9)',
    phone: 'Simu',
    photo: 'Picha',
    poll: 'Kura',
    position: 'Nafasi',
    processing: 'Inachakata',
    privacy_settings: 'Mipangilio ya faragha',
    question: 'Swali',
    quiz_create: 'Unda Jaribio Mpya',
    quiz_name: 'Jina la Jaribio',
    quiz_update: 'Sasisha jaribio',
    select_organization: 'Chagua shirika',
    settings: 'Mipangilio',
    show: 'Onyesha',
    show_graph: 'Onyesha matokeo kwa grafu',
    signin: 'Ingia',
    signup: 'Jisajili',
    sort_by: 'Panga kwa',
    start_date: 'Tarehe ya kuanza',
    tags: 'Tepe',
    terms: 'Ninakubali <1> sheria na masharti haya </1>.',
    title: 'Kichwa',
    topics: 'Mada',
    topic: 'Mada',
    total_comments: 'Jumla ya Maoni',
    username: 'Jina la mtumiaji',
    users_list: 'Orodha ya Watumiaji',
    users_emails: 'Ingiza barua pepe za watumiaji',
    description_specifiction_email:
      'Tafadhali ingiza anwani 1 ya barua pepe kwa kila mstari ili kushiriki hii na watumiaji maalum.',
    message_specific_email: ' Tafadhali ingiza barua pepe ya mtumiaji maalum.',
    viewers: 'Watazamaji',
    edit_course: 'Hariri',
    edit_assessment: 'Hariri',
    edit_event: 'Hariri',
    delete_course: 'Futa',
    delete_event: 'Futa',
    delete_assessment: 'Futa',
    view_course: 'Tazama',
    view_event: 'Tazama',
    view_assessment: 'Tazama',
    date_event: 'Tarehe ya tukio moja kwa moja',
    date_assessment: 'Tarehe ya tathmini ya moja kwa moja',
    clone_of: 'Clone',
    clone_course:
      'Unda clone ya kozi hii ambayo unaweza kurekebisha bila ya asili   inajumuisha masomo yote na kurasa.',
    make: 'Fanya',
    available_to: 'Inapatikana kwa mtumiaji yeyote wa ShareLook',
    uploaded_by: 'Imepakiwa na: ',
    course: 'Kozi',
    assessment: 'Tathmini',
    user_not_exist: 'Mtumiaji hayupo   ungependa kutuma mwaliko?',
    check_user: 'Ilani',
    user_not_exist_in_org:
      'Mtumiaji hayupo katika shirika hili   ungependa kutuma mwaliko?',
    title_modal_stream:
      'Badili kikomo cha shirika cha utiririshaji wa moja kwa moja',
    des_warning_stream: 'Umekaribia kubadili',
    monthly_stream: 'Kila kikomo cha mwezi cha utiririshaji wa moja kwa moja:',
    min_per_month: 'Dakika / mwezi',
    broadcast_label: 'Ninataka kufanya:',
    hosts_emails: 'Ingiza barua pepe maalum za mwenyeji ',
    attendee_emails: 'Ingiza barua pepe maalum za waliohudhuria',
    description_host_specifiction_email:
      'Tafadhali ingiza anwani 1 ya barua pepe kwa kila mstari.',
    presenter_label: 'Mtangazaji',
    presenter_label_conference: 'idadi ya watu',
    event_privacy: 'Mbinu ya Mkutano',
    // added_second
    alert: 'Tahadhari!',
    warning: 'Onyo!',
    ok: 'Sawa',
    cancel: 'Ghairi',
    done: 'Imekamilika',
    insert: 'Ingiza',
    private: 'Binafsi',
    public: 'Umma',
    no_connection: 'Uunganisho wa Mtandaoni Umepotea',
    switch: 'Badili',
    share_screen: 'Shiriki Skirini',
    stop_share_screen: 'Acha Kushiriki Skirini',
    share_screen_with_camera: 'Shiriki Skrini na kamera',
    stop_share_screen_with_camera: 'Acha Kushiriki Skrini na kamera',
    camera_on: 'Kamera Imewashwa',
    camera_off: 'Kamera Imezimwa',
    mic_on: 'Cheza sauti',
    mic_off: 'Zima sauti',
    fullscreen: 'Skrini kamili',
    live_now: 'Moja kwa moja sasa hivi',
    schedule_on: 'Ratiba ya',
    organisations: 'Mashirika',
    org_groups: 'Vikundi vya Shirika',
    specific_user: 'Mtumiaji Maalum',
    gif: 'GIF',
    unavailable: 'haipatikani',
    yes: 'Ndio',
    no: 'Hapana',
    event_duration_message: 'Upeo wa dakika 300 (5hrs)',
    send_email: 'Tuma Arifa ya barua pepe',
    admin_only: 'Msimamizi tu',
    join: 'Jiunge',
    leave: 'Ondoka'
  },

  broadcastOptions: {
    stream_from_phone: 'Matangazo ya moja kwa moja na simu yangu',
    other_webrtc: 'Webinar kutoka kwa Kompyuta',
    multihost: 'Multicast webinar kutoka kwa kompyuta',
    peer2peer: 'Kikao cha kufundisha',
    conference: 'Mkutano wa Moja kwa Moja'
  },

  lessoncreate: {
    title: 'Ongeza maelezo ya somo',
    subtitle:
      ' Lipe jina somo lako na uwaambie watazamaji wako kile wanatarajia kujifunza kutoka kwake.',
    input_label_title: 'Kichwa cha Somo',
    input_label_topics: 'Mada za masomo',
    input_label_description: 'Maelezo ya somo',
    delete_warning: ' Je! Una uhakika unataka kufuta ukurasa huu?'
  },

  lessonoverview: {
    title: 'Ongeza Somo',
    subtitle: 'Ongeza somo lililopo au unda mpya',
    new_lesson: 'unda somo mpya',
    new_lesson_sub: 'Tengeneza somo jipya kutoka mwanzo!',
    existing_lesson: 'Chagua somo lililopo',
    existing_lesson_sub:
      'Unganisha na somo lililopo   mabadiliko yaliyofanywa kwa somo hili pia yataathiri somo hili katika kozi zingine.',
    clone_lesson: 'fanya tena somo lililopo',
    clone_lesson_sub:
      'Tengeneza nakala ya kipekee ya somo katika kozi hii   mabadiliko yaliyofanywa kwa somo hili hayataathiri somo la awali.',
    clone_lesson_modal_sub:
      'Tafadhali bonyeza kitufe cha chini cha somo ambalo ungependa kuongeza kwenye kozi yako.'
  },

  management: {
    groups_title: 'Dhibiti Vikundi',
    delete_warning: 'Una uhakika?',
    organizations_title: 'Mashirika yangu',
    organizations_subtitle: '  Ongeza mashirika kwenye orodha yako',
    users_title: 'Dhibiti Watumiaji',
    users_position: 'Meneja Mkuu wa Akaunti',
    user_not_found: 'Mtumiaji Hajapatikana',
    select_org: 'Tafadhali pata na uchague shirika la kusimamia watumiaji'
  },

  audio: {
    modal_title: 'Ingiza Sauti',
    list_view: 'Tazama Orodha',
    create_audio_modal_title: 'Unda Sauti',
    edit_audio_modal_title: 'Hariri Sauti',
    public_audio_not_found: 'Sauti haipatikani.',
    private_audio_not_found: 'Bado haujapakia sauti yoyote',
    org_audio_not_found: 'Sauti haipatikani.',
    are_you_sure_to_delete: 'Je! Una uhakika unataka kufuta?',
    type_something: 'Chapa kitu',
    select_voice: 'Chagua',
    file_name: 'Jina la faili',
    description: 'Maelezo',
    topic: 'Mada',
    key_words_tag: 'Lebo ya Maneno muhimu',
    mp3_audio: 'MP3 Audio',
    created: 'Imeundwa',
    duration: 'Muda',
    close: 'funga'
  },

  image: {
    modal_title: 'Ingiza Picha',
    image: 'Picha',
    pixel: 'Pixel',
    dimension: 'Vipimo',
    public_image_not_found: 'Picha haikupatikana.',
    private_image_not_found: 'Bado haujapakia picha yoyote',
    org_image_not_found: 'Picha haikupatikana.'
  },

  annotation: {
    modal_title: 'Ufafanuzi'
  },

  text: {
    modal_title: 'Hariri ya maandishi'
  },

  video: {
    modal_title: 'Ingiza Video',
    image: 'Video',
    mp4_video: 'Video ya MP4',
    public_video_not_found: 'Video haipatikani.',
    private_video_not_found: 'Bado haujapakia video yoyote',
    org_video_not_found: 'Video haipatikani.'
  },

  media: {
    title: 'Maktaba ya Media',
    subtitle: 'Maktaba ya faili zako',
    modal_title: 'pakia media',
    delete_warning: 'Thibitisha kufuta',
    delete_message:
      'Media iliyofutwa bado itaonekana kwenye kurasa ambazo zilitumiwa',
    dropzone_text: 'au Buruta na Ushushe',
    delete_success: 'Media imeondolewa kwa mafanikio',
    upload_file: 'Pakia faili',
    drag_drop: 'au Buruta na Ushushe',
    import_file: 'Toa faili (faili) kutoka kwa kompyuta yako',
    no_media: 'Bado haujapakia media yoyote',
    media_type: 'Aina ya media',
    video: 'Video',
    image: 'Picha',
    audio: 'Sauti',
    gif: 'GIF',
    transcribed_text: 'Transcribed Text',
    media_not_found: 'Media haikupatikana.',
    of: 'ya',
    disclaimer: `Ninasisitiza kwamba media yangu haina:
     - kukiuka haki za mtu yeyote wa tatu
     - Inayo uharamia wowote   pamoja na uchafu
     - Inashambulia mtu yeyote kwa watu wengine
     - Inayo uigaji wowote wa washiriki wengine   takwimu za umma au watu mashuhuri
     - ina habari yoyote ya kibinafsi kwa mtu yeyote bila idhini ya mtu huyo na sio kwa kukiuka kanuni yoyote ya ulinzi wa data katika sehemu yoyote ya ulimwengu
     - Inayo rufaa ya kibiashara au aina yoyote ya "barua taka”`,

    // added_first
    my_media: 'Media Yangu',
    public_library: 'Maktaba ya Umma',
    organization_library: 'Maktaba ya shirika',
    upload_from_computer: 'Pakia kutoka kwa Kompyuta',
    pexel_images: 'Picha za Pexel',
    create: 'Unda',
    all: 'Wote',
    male: 'Mwanaume',
    female: 'Mwanamke',
    processing_audio: 'Inashughulikia Sauti',
    create_annotation: 'Unda Ujumbe',
    popup_over_lesson_text:
      'Maelezo haya yatatoka kwenye ukurasa wa somo baada ya kubonyeza',
    edit_detail: 'Hariri Maelezo',
    delete: 'Futa',
    go_create_audio: 'Nenda Unda Sauti',
    show_more_details: 'onyesha maelezo zaidi',
    show_less_details: 'onyesha maelezo kidogo',
    drop_files: 'Tupa faili na mahali pa kupakia',
    or: 'Au',
    import_files: 'Ingiza faili kutoka kwa kompyuta'
  },

  navigation: {
    account: 'Akaunti',
    assessments: 'Tathmini',
    dashboard: 'Dashibodi',
    groups: 'Usimamizi wa Kikundi',
    logout: 'Ondoka',
    organisations: 'Mashirika',
    organizations_users: 'Mashirika na Watumiaji',
    reports: 'Ripoti',
    schedule: 'Ratiba',
    training: 'Mafunzo',
    users: 'Watumiaji',

    // added_first
    nowLive: 'moja kwa moja',

    workshop: 'Warsha yangu'
  },

  onboarding: {
    step1_title: 'Hatua ya 1: Tuambie Kidogo Kuhusu Wewe mwenyewe',
    step1_subtitle: 'Jina lako nani? Unatoka wapi? Jina lako la kazi ni?',
    step2_title: 'Hatua ya 2: Chagua Ustadi Wengine Uliweza Kuboresha Katika',
    step2_subtitle:
      'Ijayo   tuambie nini ungependa kuelewa vizuri zaidi. Labda kitu ambacho bado unachohitaji kuchukua? Uwanja mpya wa kusoma? Je! Mpendwa wako anafanya nini?'
  },

  pagebuilder: {
    title: 'Unda Somo',
    subtitle:
      'Wakati wa kuunda yaliyomo kwa watazamaji wako kujifunza kutoka kwako   unaweza kupiga picha   video na infographics',
    select_layout: 'Chagua Mpangilio wa Ukurasa',
    template1: 'Blank',
    template2: 'Kichwa & Manukuu',
    template3: 'Kichwa & Maandishi',
    template4: 'Kichwa   Media na Nakala',
    template5: 'Kichwa & Media',
    template6: 'Kichwa & Jaribio'
  },

  pageconstructor: {
    title: 'Unda na Somo la Clone',
    subtitle:
      'Wakati wa kuunda yaliyomo kwa watazamaji wako kujifunza kutoka kwako   unaweza kuongeza picha   video na infographics'
  },

  passwordreset: {
    success_coded:
      'Tumetuma nambari ya uthibitisho kwa barua pepe kwa anwani uliyotoa   tafadhali nakili nambari hiyo kwenye uwanja hapa chini kuweka nenosiri mpya.',
    success_changed: 'Umefanikiwa kuweka nywila mpya. Unaweza kuingia sasa.'
  },

  placeholders: {
    search: 'Tafuta',
    answer: 'Jibu',
    chat: 'Sema kitu…',
    code: 'Code',
    criterion: 'Furqani',
    date_event: 'Chagua tarehe na wakati',
    date_start: 'Tarehe ya kuanza',
    date_expire: 'Tarehe ya mwisho wa matumizi',
    description: 'Maelezo',
    elements: 'Panga vitu',
    email: 'Barua pepe',
    feedback_correct: 'Maoni ni Sahihi',
    feedback_incorrect: 'Maoni Sio sahihi',
    host: 'Mwenyeji',
    keywords: 'Tafuta Maneno muhimu',
    lesson_description: 'Maelezo ya somo',
    location: 'Mahali',
    minutes: 'Dakika',
    name: 'Jina',
    organiser: 'Mwandishi',
    organization: 'Shirika',
    password: 'Nenosiri',
    phone: 'Simu',
    photo: 'Picha',
    picture: 'Picha',
    point: 'Kidokezo',
    position: 'Nafasi',
    question: 'Swali',
    quiz: 'Jina la jaribio',
    search_course: 'Tafuta na Kozi',
    search_media: 'Tafuta media',
    search_name: 'Tafuta kwa Jina',
    search_title: 'Tafuta na Kichwa',
    search_training: 'Tafuta Mafunzo',
    settings: 'Mipangilio',
    tags: 'Tepe',
    title: 'Kichwa',
    topics: 'Mada',
    username: 'Jina la mtumiaji',
    keyword: 'Maneno muhimu',
    max_500_characters: 'isipite herufi 500',
    no_description: 'Faili hii haina maelezo',
    no_keyword: 'Faili hii haina maneno muhimu yoyote',
    no_topics: 'Faili hii haina seti ya mada',
    feedback: 'Ujumbe',
    contact: 'Jinsi tunaweza kusaidia?'
  },

  publishsettings: {
    title: 'Mipangilio ya Kuchapisha',
    event_subtitle:
      'Ongeza mipangilio kwenye hafla yako   ambaye anaweza kutazama na kuingiliana na tukio lako',
    assessment_subtitile:
      'Taja tathmini yako na uwaambie watazamaji wako kile wanatarajia kujifunza kutoka kwake',
    course_subtitle:
      'Ongeza mipangilio kwenye kozi yako   ni nani anayeweza kutazama na kuingiliana na kozi yako',
    disclaimer:
      'Lorem ipsum dolor sit amet   consectetur adipiscing elit. Nullam venenatis tellus ex   eu auctor diam tristique et. Fusce vel egestas felis   vel malesuada justo. Suspendisse erat orci   dapibus a nisi quis   ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus   porta in porta eu   accumsan a purus. Donec quis turpis vestibulum   consequat urna ut   vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor   turpis et tincidunt lobortis   dui tortor viverra risus   quis venenatis Lorem ipsum dolor sit amet   consectetur adipiscing elit. Nullam venenatis tellus ex   eu auctor diam tristique et. Fusce vel egestas felis   vel malesuada justo. Suspendisse erat orci   dapibus a nisi quis   ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus   porta in porta eu   accumsan a purus. Donec quis turpis vestibulum   consequat urna ut   vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor   turpis et tincidunt lobortis   dui tortor viverra risus   quis venenatis Lorem ipsum dolor sit amet   consectetur adipiscing elit. Nullam venenatis tellus ex   eu auctor diam tristique et. Fusce vel egestas felis   vel malesuada justo. Suspendisse erat orci   dapibus a nisi quis   ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus   porta in porta eu   accumsan a purus. Donec quis turpis vestibulum   consequat urna ut   vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor   turpis et tincidunt lobortis   dui tortor viverra risus   quis venenatis Lorem ipsum dolor sit amet   consectetur adipiscing elit. Null am venenatis tellus ex   eu auctor diam tristique et. Fusce vel egestas felis   vel malesuada justo. Suspendisse erat orci   dapibus a nisi quis   ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus   porta in porta eu   accumsan a purus. Donec quis turpis vestibulum   consequat urna ut   vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor   turpis et tincidunt lobortis   dui tortor viverra risus   quis venenatis Lorem ipsum dolor sit amet   consectetur adipiscing elit. Nullam venenatis tellus ex   eu auctor diam tristique et. Fusce vel egestas felis   vel malesuada justo. Suspendisse erat orci   dapibus a nisi quis   ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus   porta in porta eu   accumsan a purus. Donec quis turpis vestibulum   consequat urna ut   vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor   turpis et tincidunt lobortis   dui tortor viverra risus   quis venenatis Lorem ipsum dolor sit amet   consectetur adipiscing elit. Nullam venenatis tellus ex   eu auctor diam tristique et. Fusce vel egestas felis   vel malesuada justo. Suspendisse erat orci   dapibus a nisi quis   ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus   porta in porta eu   accumsan a purus. Donec quis turpis vestibulum   consequat urna ut   vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor   turpis et tincidunt lobortis   dui tortor viverra risus   quis venenatis',
    dates_validation_error: 'Tarehe zote mbili zinapaswa kujazwa.',
    emails_validation_error: 'Orodha ya barua pepe sio sahihi.',
    specific_email_validation_error: 'Barua pepe moja tu ndiyo inaruhusiwa.',
    i_agree_to_these: 'Ninakubali hizi',
    terms_and_conditions: 'sheria na Masharti.',
    PublicDescription:
      'Watumiaji wa bure huria: (chaguzi za kibinafsi na za umma) [Kozi yako | Tukio | Tathmini] imehifadhiwa na inachukuliwa kuwa ya faragha. Hii inamaanisha kuwa wewe tu unaweza kuona maudhui haya. Ili kuchapisha maudhui haya unaweza kuchagua kuifanya iwe ya umma chini. Hii inamaanisha kuwa kozi hiyo itapatikana kwa watumiaji wote kwenye jukwaa.',
    OrganisationsDescription:
      'Watumiaji wa  Shirika: (Badala ya "" Maliza "" tumia "" Chapisha "" na uwalete kwenye ukurasa wa kuchapisha sawa na watumiaji wengine lakini bila chaguzi zozote za kuchapisha.) [Kozi ya Tukio | Tathmini yako] imehifadhiwa na ni ya kibinafsi. Hii inamaanisha kuwa wewe na watawala katika shirika lako ndio mnaweza kuiona. Kama mtumiaji   hauwezi kuchapisha yaliyomo ndani ya shirika lako mwenyewe kwani hii inahitaji haki za msimamizi. Tafadhali wasiliana na mmoja wa Wasimamizi wako na uwaombe wachapishe yaliyomo kwako hadharani   kwa shirika lote   kwa vikundi maalum ndani ya shirika lako au kwa watumiaji fulani.',
    OrganisationGroupsDescription:
      'Msimamizi wa shirika: (Kwa yaliyomo ndani ya shirika: Binafsi   umma   shirika   vikundi   watumiaji fulani): Hii [Kozi ya Tukio | Tathmini] imehifadhiwa na inachukuliwa kuwa ya faragha. Hii inamaanisha kuwa wewe tu (na muundaji wa yaliyomo) ndiye anayeweza kuona maudhui haya. Ili kuchapisha maudhui haya unaweza kuchagua moja ya chaguzi hapa chini. Kuchapisha kozi yako kwa Umma kunamaanisha kuwa itapatikana kwa watumiaji wote kwenye jukwaa - pamoja na wale walio nje ya shirika lako. Kuichapisha kwa shirika kunamaanisha kuwa watumiaji wote ndani ya shirika wataweza kuiona. Unaweza kuichapisha kwa vikundi 1 au zaidi   ikimaanisha watumiaji tu kwenye vikundi hivyo wataweza kuiona. Mwishowe   una chaguo la kuchapisha kwa watumiaji maalum ndani na nje ya shirika lako kwa kutumia anwani yao ya barua pepe ya akaunti ya ShareLook.',
    SpecificUsersDescription:
      'Watumiaji wa Uhuru waliolipwa: (ya kibinafsi   ya umma na watumiaji maalum) [Kozi ya [Tukio lako] Tathmini] Imehifadhiwa na inachukuliwa kuwa ya faragha. Hii inamaanisha kuwa wewe tu unaweza kuona maudhui haya. Ili kuchapisha maudhui haya unaweza kuchagua moja ya chaguzi hapa chini. Kuchapisha kozi yako kwa Umma kunamaanisha kuwa itapatikana kwa watumiaji wote kwenye jukwaa. Chaguo Maalum la Watumiaji litakuwezesha kushiriki kozi yako na watumiaji maalum kwa kutumia anwani ya barua pepe inayohusiana na akaunti yao ya ShareLook.'
  },

  quiz: {
    quiz_empty: 'Bado haujafanya jaribio',
    questions_empty: 'Bado haujaunda swali'
  },

  regions: {
    asia_pacific_australia: 'Australia',
    asia_pacific_india: 'India',
    asia_pacific_japan: 'Japan',
    asia_pacific_s_korea: 'Korea Kusini',
    asia_pacific_singapore: 'Singapore',
    asia_pacific_taiwan: 'Taiwan',
    eu_belgium: 'Ubelgiji',
    eu_germany: 'Ujerumani',
    eu_ireland: 'Ireland',
    south_america_brazil: 'Brazil',
    us_central_iowa: 'Iowa',
    us_east_s_carolina: 'South Carolina',
    us_east_virginia: 'Virginia',
    us_west_california: 'California',
    us_west_oregon: 'Oregon'
  },
  reports: {
    title: 'Ripoti',

    // added_first
    workshop_report: 'Ripoti ya Warsha',
    user_report: 'Ripoti ya Mtumiaji',
    organization_workshop: 'Warsha ya shirika',
    course: 'Kozi',
    live_event: 'Tukio la moja kwa moja',
    workShop_graph: 'Grafu ya Warsha',
    organization_account: 'Akaunti ya shirika',
    all: 'Wote',
    name: 'Jina',
    id_number: 'Nambari ya kitambulisho',
    email: 'Barua pepe',
    search_user_report: 'Tafuta Ripoti ya Mtumiaji',
    participant: 'Mshiriki',
    participants: 'Washiriki',
    host: 'Mwenyeji',
    username: 'Jina la mtumiaji',
    event: 'Tukio',
    quiz: 'Jaribio',
    assessment: 'Tathmini',
    time: 'Wakati',
    no_recent_activity: 'Hakuna shughuli ya Hivi majuzi',
    workshops: 'Warsha',
    courses: 'Kozi',
    live_events: 'Matukio ya moja kwa moja',
    live_assessments: 'Tathmini za Moja kwa moja',
    quizzes: 'Majaribio',
    overview: 'Maelezo ya jumla',
    by: 'Na',
    views: 'Maoni',
    status: 'Hali',
    poll: 'Kura',
    comment: 'Maoni',
    comments: 'Maoni',
    no_comments: 'Hakuna maoni',
    no_polls: 'Hakuna Kura',
    live_date: 'Tarehe ya moja kwa moja',
    score: 'Alama',
    question: 'Swali',
    submit: 'Tuma',
    recent_activity: 'Shughuli za hivi karibuni',
    ago: 'Iliyopita',
    no_data_found: 'Hakuna data iliyopatikana',
    start_end_live: 'Anza / Maliza tukio la moja kwa moja',
    join_leave_date: 'Jiunge / Ondoka',
    watched_time: 'Wakati uliotengwa',
    complete: 'Kamilisha',
    in_complete: 'Katika Kukamilisha',
    today: 'Leo',
    seven_days: 'Siku 7',
    last_month: 'Mwezi uliopita',
    one_year: 'Mwaka 1',
    all_time: 'Muda wote',
    report: 'Ripoti',
    from_date: 'Kuanzia Tarehe',
    to_date: 'Mpaka leo',
    all_workshop: 'Warsha Yote',
    all_participants: 'Washiriki wote',
    live_assessment: 'Tathmini ya Moja kwa moja',
    users: 'Watumiaji',
    download: 'Pakua',
    recent: 'Hivi karibuni',
    WorkShop: 'Warsha',
    Activity: 'Shughuli',
    created_date: 'Tarehe iliyoundwa',
    lessons: 'Masomo',
    lesson: 'Somo',
    completed: 'Imekamilika',
    report_download: 'Pakua ripoti',
    this_month: 'Mwezi huu',
    search_course: 'Kozi ya Kutafuta',
    participants_graph: 'Wagiriki washiriki',
    viewed: 'Imetazamwa',
    enrolled: 'Imeandikishwa',
    description: 'Maelezo',
    topic: 'Mada',
    analytic: 'Mchanganuzi',
    quiz_list: 'Orodha ya jaribio',
    select_one: 'Chagua moja',
    group_status: 'Hali ya kikundi',
    duration_min: 'Muda (dakika)',
    submit_poll: 'Tuma kura',
    download_events: 'Pakua Matukio',
    search_event: 'Tukio la utaftaji',
    duration: 'Muda',
    total_participants: 'washiriki wote',
    message: 'Ujumbe',
    avg_message: 'Ujumbe wa wastani',
    per_message: 'Asilimia ya ujumbe/tukio'
  },

  signup: {
    success_step1:
      'Tumetuma nambari ya ukaguzi kwa barua pepe uliyotoa   tafadhali nakili nambari katika uwanja ulio chini ili uthibitishe usajili wako.',
    success_step2:
      'Tumetuma nambari ya ukaguzi kwa barua pepe uliyotoa   tafadhali nakili nambari katika uwanja ulio chini ili uthibitishe usajili wako.',
    privacy: `Ninakubali Sheria na Masharti ya Sharelook </1> na <2> sera ya faragha`
  },

  stream: {
    emotion_impressive: 'Kuvutia',
    emotion_unimpressive: 'Haifurahishi',
    message_not_started: 'Yajao Hivi karibuni',
    message_running: 'Moja kwa moja',
    message_processing:
      'Hivi sasa tunashughulikia rekodi ya moja kwa moja ya kucheza tena. Tafadhali angalia tena baadaye kutazama video na kuendelea kuongeza ukadiriaji na maoni'
  },

  tabs: {
    audience: 'Watazamaji',
    course: 'muhtasari wa kozi',
    details: 'Maelezo ya Tukio la Moja kwa Moja',
    description: 'Maelezo',
    host: 'mwenyeji',
    lesson: 'Maelezo ya Jumla ya Somo',
    lessons: 'Masomo',
    overview: 'Maelezo ya jumla',
    page: 'Mjenzi wa Ukurasa',
    publish: 'Chapisha',
    settings: 'Mipangilio ya kuchapisha',
    total_views: 'Jumla ya utazamaji',
    live_participates: 'Washiriki wa Moja kwa Moja',
    live_chats: 'Maongezi ya moja kwa moja',
    live_quiz: 'Kura za moja kwa moja',
    trainer_rating: 'Kiwango vya mkufunzi',
    trainer_times: 'wakati wa Mkufunzi',
    courses_quizzes: 'majaribio ya kozi',
    user_list: 'Orodha ya Watumiaji',
    discussion: 'Majadiliano',
    notes: 'Vidokezo Vyangu'
  },

  topics: {
    SALES_TRAINING: 'Mafunzo ya Uuzaji',
    NEGOTIATION_TRAINING: 'Mafunzo ya Mazungumzo',
    CROSS_CULTURAL_AWARENESS: 'Utafahamu wa Kitamaduni',
    NETWORKING_SKILLS: 'Ujuzi wa Kuungana',
    SOFTWARE_ARCHITECTURE: 'Usanifu wa Programu',
    PROJECT_MANAGEMENT: 'Usimamizi wa Mradi',
    DIGITAL_TRANSFORMATION: 'Mabadiliko ya dijiti',
    IT_CONSULTING: 'Ushauri wa IT',
    MANAGEMENT_CONSULTING: 'Ushauri wa Usimamizi',
    HR_CONSULTING: 'Ushauri wa wafanyikazi',
    INTERNET_OF_THINGS: 'Mtandao wa Vitu (IoT)',
    CYBERSECURITY: 'Utapeli wa cyber',
    PRIVACY_AND_GDRP: 'Usiri na GDPR'
  },

  training: {
    title: 'Mafunzo',
    title_assessment: 'Tathmini',
    subtitle: 'Kozi na Matukio ya Moja kwa Moja',
    enrolled_title: 'Kozi zilizosajiliwa na Matukio ya Moja kwa Moja',
    enrolled_subtitle: 'Kozi na Matukio ya Moja kwa moja ambayo umejiandikisha',
    enrolled_message: 'Kwa sasa haujaandikishwa kwenye kozi zozote na tukio.',
    past_live_event_title: 'Matukio ya Awali ya Moja kwa Moja',
    past_live_event_subTitle: 'Malizo ya Matukio Moja yaliyomalikiza',
    past_live_event: 'Hivi sasa hakuna matukio ya zamani.',
    recomended_title: 'Kozi zilizopendekezwa na Matukio ya Moja kwa Moja',
    now_live_event_title: 'Matukio ya Moja kwa Moja iliyopo sasa',
    now_live_event_subTitle:
      'Matukio ambayo ni ya moja kwa moja au yatakuja hivi karibuni',
    now_live_event: 'Hivi sasa hakuna tukio moja kwa moja.',
    webinar_event_title: 'Kituo cha Webinar',
    webinar_event_subTitle: 'Webinars zilizo malizika',
    webinar_event: 'Hivi sasa hakuna webinar.',
    p2p_event_title: 'Vikao vya Kufundisha',
    p2p_event_subTitle: 'Kumaliza cha kufundisha kilicho malizika',
    p2p_event: 'Hivi sasa hakuna kikao cha kufundisha.',

    now_live_assessment_title: 'moja kwa moja ipo',
    now_live_assessment_subTitle:
      'Tathmini ambayo ni moja kwa moja au itakuwa hivi karibuni',
    now_live_assessment_message: 'Kwa sasa hakuna tathmini ya moja kwa moja.',

    upcoming_assessment_title: 'Tathmini za Moja kwa Moja zijazo',
    upcoming_assessment_subtitle: 'Tathmini za Moja kwa Moja zijazo',
    upcoming_assessment_message:
      'Kwa sasa hakuna tathmini ya moja kwa moja inayokuja.',

    past_live_assessment_title:
      'Kwa sasa hakuna tathmini ya moja kwa moja inayokuja',
    past_live_assessment_subTitle:
      'Amemaliza Tathmini za Moja kwa Moja zilizomalizika',
    past_live_assessment_message:
      'Hivi sasa hakuna tathmini za moja kwa moja zilizopita.',

    /**
     * <0/> get index 0 of data from Trans component
     * exp -->
     * <Trans i18nKey='training:recomended_subtitle' >
     *    <Navlink>{...something}</Navlink> --> is index 0 of Trans component
     *    <h1>{...something}</h1> --> is index 1 of Trans component
     * </Trans>
     */
    recomended_subtitle:
      'Tumefundisha kozi na matukio ya moja kwa moja kulingana na <0><0/> </0>',
    /**
     * and we also can get data from index to replace in recommended_subtitle by like above string.
     * for exp -->
     * at the end of the recomended_subtitle above will get data from index of component to display
     * <0><0/></0> mean get data index 0 of Trans component above = <Navlink> and <0/> get data index 0 from <Navlink> = {...something}
     */
    search: 'Tafuta Mafunzo',
    search_assessment: 'Tafuta Tathmini',
    recomended_message: 'Hivi sasa hakuna kozi na hafla zilizopendekezwa.',
    search_user: 'tafuta jina la kampuni'
  },
  warnings: {
    delete: 'Una uhakika?'
  },

  workshop: {
    title: 'Warsha yangu',
    subtitle: 'Tengeneza kozi au ushiriki hafla yako mwenyewe',
    new_course: 'Tengeneza kozi mpya',
    new_event: 'Unda hafla mpya ya moja kwa moja',
    new_assessment: 'Tengeneza tathmini mpya ya moja kwa moja',
    courses_title: 'Kozi zilizoundwa na Matukio ya Moja kwa Moja',
    courses_subtitle:
      'Hariri na Chapisha kozi yako iliyoundwa na upange matukio ya moja kwa moja',
    tags_course: 'Kozi',
    tags_live: 'Tukio la Moja kwa Moja',
    tags_assessment: 'Tathmini ya Moja kwa Moja'
  },

  help_center: {
    sidebar: {
      title: 'Tunawezaje kukusaidia?',
      back_to: 'Dashibodi'
    },
    menu: {
      help_center: 'Kituo cha Msaada',
      whats_new: 'Nini mpya',
      feedback: 'Maoni',
      feedback_title: 'Tuma maoni kwa ShareLook',
      terms_and_conditions: 'Sheria na Masharti',
      privacy_policy: 'Sera ya faragha',
      contact_us: 'Wasiliana nasi'
    },
    get_started: {
      title: 'Anza na ShareLook',
      description: {
        main:
          'TUMEUNGANISHA VIDEO YA MOJA KWA MOJA KUWA URAHISI WA KUTUMIA MJENZI WA KOZI',
        tagline:
          'Na mfumo wa matangazo ya moja kwa moja wa hakimiliki ya ShareLook   unaweza kuunda ushirika   kurahisisha kujifunza   na kuongeza kushiriki kushiriki maarifa.'
      }
    },
    whats_new: {
      title: 'Anza na ShareLook',
      description: {
        main:
          'Je! Ulijua kwamba kuunda ujifunzaji wa hadithi za hadithi kunaweza kuunda katika muda mfupi na sio ghali sana? Unapaswa kuchanganya mjenzi wa kozi ya ShareLook na talanta husika. Unaweza kutuuliza "JINSI',
        tagline: ''
      }
    },
    create_workshop: 'Jinsi ya kuunda Warsha',
    create_course: 'Jinsi ya kuunda Kozi',
    create_user: 'Jinsi ya kuunda Mtumiaji',
    create_group: 'Jinsi ya kuunda Kikundi',
    create_webinar: 'Jinsi ya kuunda Webinar',
    create_live_event: 'Jinsi ya kuunda Tukio la Moja kwa Moja',
    create_live_assessment: 'Jinsi ya kuunda Tathmini ya Moja kwa Moja',
    create_live_on_mobile: 'Unda Moja kwa moja kwenye Simu ya Mkononi',
    personalize_profile: 'Kubinafsisha wasifu',
    manage_group: 'Dhibiti kikundi',
    report: 'Ripoti',
    add_annotations: 'Jinsi ya Kuongeza Vidonge',
    add_audio: 'Jinsi ya Kuongeza Sauti',
    add_header_and_footer: 'Kuongeza kichwa na nyayo',
    add_image: 'Jinsi ya Kuongeza Picha',
    add_quiz_content: 'Jinsi ya Kuongeza Yaliyomo kwenye majaribio',
    add_text_content: 'Jinsi ya Kuongeza maandishi',
    add_user: 'Jinsi ya Kuongeza Mtumiaji',
    add_video: 'Jinsi ya Kuongeza Video',
    clone_course: 'Jinsi ya kuclone Kozi',
    find_live_broadcast: 'Jinsi ya kupata Matangazo ya moja kwa moja',
    contact_us: {
      title: 'Wasiliana nasi',
      subject_placeholder: 'Ingiza somo*',
      content_placeholder: 'Ingiza ujumbe*',
      subject_required: '*Mada inahitajika',
      content_required: '*Ujumbe unahitajika',
      submit: 'Tuma',
      cancel: 'Ghairi',
      sent: 'Imetumwa'
    },
    feedback: {
      title: 'Tuma maoni kwa ShareLook',
      attach_title: 'Ambatisha faili',
      choose: 'Chagua faili',
      detail: 'Faili itashirikiwa na timu ya msaada',
      content_placeholder: 'Ingiza ujumbe*',
      content_required: '*Ujumbe unahitajika',
      submit: 'Tuma',
      cancel: 'Ghairi',
      sent: 'Imetumwa'
    }
  },
  discussion: {
    join_discussion: 'Jiunge na majadiliano'
  },
  notes: {
    title: 'Vidokezo Vyangu',
    add_note: 'Ongeza kidokezo kipya'
  },
  // added_third
  groups: {
    search_group: 'Tafuta kikundi cha shirika'
  }
}
